function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWritingRoomBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.39,237.44c-4.91,41.61-23.91,90-61.85,112.21C341.21,383.24,346,434.9,234.11,457.35A229.81,229.81,0,0,1,184.49,462a191,191,0,0,1-24.35-2C89,449.67,41.16,400.23,23.6,340.56.5,262.08,46.63,210.7,77.22,179.74S130.2,52.33,240,29.38a222.83,222.83,0,0,1,51-4.84c39.08,1,81.7,13.79,111.2,40.57q3.31,3,6.46,6.25C449.68,113.44,467.09,180.72,460.39,237.44Z",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.39,237.44c-4.91,41.61-23.91,90-61.85,112.21C341.21,383.24,346,434.9,234.11,457.35A229.81,229.81,0,0,1,184.49,462a191,191,0,0,1-24.35-2C89,449.67,41.16,400.23,23.6,340.56.5,262.08,46.63,210.7,77.22,179.74S130.2,52.33,240,29.38a222.83,222.83,0,0,1,51-4.84c39.08,1,81.7,13.79,111.2,40.57q3.31,3,6.46,6.25C449.68,113.44,467.09,180.72,460.39,237.44Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.79,447.85H11.43a.5.5,0,0,1,0-1H489.79a.5.5,0,1,1,0,1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-balls--inject-403"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "448.51 434.95 445.53 432.22 438.7 434.09 434.98 443.15 443.3 447.12 449.5 445.88 451.24 439.55 448.51 434.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.3,447.62a.54.54,0,0,1-.22-.05l-8.32-4a.5.5,0,0,1-.24-.64l3.72-9.06a.52.52,0,0,1,.33-.3l6.83-1.86a.51.51,0,0,1,.47.12l3,2.73a.48.48,0,0,1,.09.11l2.73,4.59a.49.49,0,0,1,.05.39L450,446a.51.51,0,0,1-.39.36l-6.21,1.24Zm-7.68-4.72,7.74,3.7,5.74-1.15,1.6-5.83-2.58-4.35-2.72-2.49-6.33,1.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.52,446.13h-.07l-6.2-.87a.51.51,0,0,1-.43-.42l-.87-5.59a.52.52,0,0,1,.16-.44l4.47-4.1a.48.48,0,0,1,.32-.13l4.6-.12,0,1-4.4.12L440,439.36l.77,5,5.52.77,2.78-4.61-4.2-2.31-1.12,1,4.48,1.93-.39.92-5.22-2.24a.51.51,0,0,1-.3-.38.54.54,0,0,1,.17-.46l2-1.73a.52.52,0,0,1,.57-.07l5,2.73a.49.49,0,0,1,.24.31.48.48,0,0,1-.05.39L447,445.89A.5.5,0,0,1,446.52,446.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,444l-3.6-.5a.48.48,0,0,1-.38-.28.51.51,0,0,1,0-.48l2.36-3.73.84.54-1.94,3.06,2.83.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.53,432.22l2.23.5,2.49,2.11,2.11,2.36s1.11,3,.74,3.48a14.3,14.3,0,0,0-1,2.48l-2.11.74,1.24-4.34L448.51,435Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,444.39a.47.47,0,0,1-.34-.13.49.49,0,0,1-.14-.5l1.18-4.14-2.58-4.35-2.93-2.68a.5.5,0,0,1-.1-.6.49.49,0,0,1,.55-.25l2.23.49a.57.57,0,0,1,.22.11l2.48,2.11,2.16,2.41a.78.78,0,0,1,.1.15c.8,2.15,1,3.48.67,4a12.55,12.55,0,0,0-.91,2.33.52.52,0,0,1-.31.32l-2.11.75Zm-2.76-11.27,1.61,1.47a.48.48,0,0,1,.09.11l2.73,4.59a.51.51,0,0,1,.05.4l-1,3.41,1-.34a11.41,11.41,0,0,1,1-2.39,11.61,11.61,0,0,0-.78-2.92l-2.05-2.29-2.33-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.82,434.82l-5.51,2.71v4.53c0,.27.18,2.26.18,2.26l4.7,3.07,4.7-.36,3.26-1.72,1.72-2.53.81-1.72s.18-2.89.27-3.16a26.34,26.34,0,0,0-.27-2.63,18.47,18.47,0,0,0-1.27-2.35l-3.07.27L421.8,433Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19,447.89a.5.5,0,0,1-.27-.08l-4.7-3.08a.51.51,0,0,1-.23-.37c0-.34-.18-2-.18-2.3v-4.52a.49.49,0,0,1,.28-.45l5.51-2.72h0l4-1.81a.39.39,0,0,1,.26,0l1.49.17,3-.26a.51.51,0,0,1,.47.23c1.34,2.2,1.34,2.48,1.34,2.61s.05.39.09.74a6.42,6.42,0,0,1,.16,2c-.05.2-.17,1.71-.25,3a.48.48,0,0,1-.05.18l-.81,1.72-1.76,2.6a.46.46,0,0,1-.18.16l-3.25,1.72a.66.66,0,0,1-.2.06l-4.7.36ZM413,444l4.35,2.85,4.43-.34,3.05-1.61,1.65-2.43.74-1.57a30.34,30.34,0,0,1,.29-3.19c0-.15-.13-1.12-.2-1.59s-.1-.77-.1-.88-.55-1-1-1.82l-2.77.24h-.1l-1.4-.16L418,435.27l-5.23,2.58v4.21C412.81,442.22,412.9,443.27,413,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.23,445.06a1.27,1.27,0,0,1-.62-.12,47.39,47.39,0,0,1-3.91-3.23.5.5,0,0,1-.14-.54c1.14-3.24,1.41-3.41,1.55-3.51s1.89-1.76,3.37-3.2a.5.5,0,0,1,.68,0l3.44,3.17a.5.5,0,0,1,.13.19L422.9,441a.48.48,0,0,1-.09.5c-2.54,2.92-2.9,3-3.05,3l-.26.07A9.1,9.1,0,0,1,417.23,445.06Zm-3.61-3.88c1.51,1.34,3.14,2.72,3.43,2.87.13.05.58.05,2.17-.41l.29-.08c.19-.13,1.34-1.37,2.35-2.51l-1-2.78-3-2.76c-1.07,1-2.91,2.82-3.16,3S414.05,440,413.62,441.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9,446.44a.51.51,0,0,1-.17,0L416.66,445a.5.5,0,0,1,.12-1l3.21-.34,1.88-2.59-1-2.8-3.34-3.08a.48.48,0,0,1-.16-.45.5.5,0,0,1,.29-.37l4-1.81a.49.49,0,0,1,.55.09l2.62,2.54a.39.39,0,0,1,.08.1l2.17,3.62a.44.44,0,0,1,.07.32l-.36,2.8a.6.6,0,0,1-.08.21l-1.81,2.8a.47.47,0,0,1-.26.2l-3.52,1.18Zm-1.83-1.68,1.83.66,3.2-1.07,1.65-2.56.33-2.52L424,435.86l-2.33-2.25-3,1.36,2.88,2.65a.5.5,0,0,1,.13.19L422.9,441a.5.5,0,0,1-.06.47l-2.17,3a.49.49,0,0,1-.35.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.28,444.72l-.9-.45,1.32-2.62.07-.8-.87-2.61a.51.51,0,0,1,.06-.45.49.49,0,0,1,.4-.21l3.89-.09,0,1-3.21.07.69,2.07a.47.47,0,0,1,0,.2l-.09,1a.41.41,0,0,1-.05.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-can--inject-403"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "403.06 385.53 405.61 388.67 412.64 387.82 417.65 379.41 410.01 374.26 403.68 374.57 401.04 380.58 403.06 385.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,389.17a.51.51,0,0,1-.39-.19l-2.54-3.14-.08-.12-2-5a.48.48,0,0,1,0-.39l2.65-6a.47.47,0,0,1,.43-.29l6.32-.32a.48.48,0,0,1,.31.08l7.64,5.15a.5.5,0,0,1,.15.67l-5,8.42a.52.52,0,0,1-.37.24l-7,.84Zm-2.11-3.9,2.33,2.87,6.5-.78,4.65-7.8-7.12-4.79-5.84.29-2.44,5.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.63,386.58h-.06L403,386l.11-1,4.38.53,4.65-3.14,0-5-5.34-1.57L403.34,380l3.81,2.9,1.26-.8-4.15-2.56.52-.85,4.83,3a.49.49,0,0,1,.24.42.54.54,0,0,1-.23.43l-2.22,1.43a.5.5,0,0,1-.57,0l-4.51-3.43a.5.5,0,0,1-.2-.34.54.54,0,0,1,.11-.37l4-4.81a.5.5,0,0,1,.53-.16l6,1.77a.49.49,0,0,1,.36.47l0,5.66a.49.49,0,0,1-.22.41l-5,3.4A.49.49,0,0,1,407.63,386.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73,382.39l-.76-.65,2.37-2.75-2.74-.8.28-1,3.49,1a.5.5,0,0,1,.34.34.48.48,0,0,1-.1.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,388.67l-2.14-.82-2.14-2.46-1.74-2.64s-.67-3.11-.23-3.55a14.05,14.05,0,0,0,1.34-2.31l2.2-.42L401,380.58l2,4.95Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,389.17a.58.58,0,0,1-.18,0l-2.13-.82a.46.46,0,0,1-.2-.13L401,385.72,399.17,383a.36.36,0,0,1-.07-.17c-.48-2.24-.51-3.59-.09-4a14.23,14.23,0,0,0,1.25-2.17.5.5,0,0,1,.35-.28l2.2-.42a.47.47,0,0,1,.48.18.5.5,0,0,1,.07.51l-1.78,3.92,1.92,4.68,2.5,3.08a.51.51,0,0,1,0,.61A.52.52,0,0,1,405.61,389.17Zm-1.84-1.75.28.11-1.37-1.69-.08-.12-2-5a.48.48,0,0,1,0-.39l1.47-3.24-1,.2a12.12,12.12,0,0,1-1.34,2.22,11,11,0,0,0,.35,3l1.69,2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.31,372.68l-6,3v4.94c0,.29.19,2.47.19,2.47l5.14,3.36,5.14-.4,3.56-1.88,1.88-2.76.89-1.88s.19-3.16.29-3.46a27.9,27.9,0,0,0-.29-2.87,20.38,20.38,0,0,0-1.39-2.56l-3.36.29-1.68-.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.62,386.92a.5.5,0,0,1-.27-.08l-5.14-3.36a.55.55,0,0,1-.23-.38c0-.36-.19-2.21-.19-2.51v-4.94a.49.49,0,0,1,.27-.45l6-3h0l4.34-2a.43.43,0,0,1,.27,0l1.63.19,3.31-.29a.48.48,0,0,1,.47.24c1.46,2.39,1.46,2.69,1.46,2.82a7.86,7.86,0,0,0,.1.81,6.69,6.69,0,0,1,.17,2.22c-.06.21-.18,1.87-.28,3.33a.53.53,0,0,1,0,.18l-.89,1.88-1.92,2.83a.49.49,0,0,1-.18.17L392,386.46a.42.42,0,0,1-.19.06l-5.14.4ZM382,382.77l4.79,3.14,4.87-.38,3.35-1.77,1.81-2.66.81-1.73c.08-1.21.22-3.18.32-3.49s-.14-1.24-.21-1.76a9,9,0,0,1-.11-.95c-.06-.15-.62-1.14-1.16-2l-3,.27h-.11l-1.54-.18-4.21,1.91L381.79,376v4.63C381.79,380.77,381.88,381.94,382,382.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.66,383.83a1.47,1.47,0,0,1-.66-.13c-.62-.31-3.65-3-4.26-3.53a.52.52,0,0,1-.14-.54c1.25-3.52,1.54-3.71,1.68-3.81s2.39-2.24,3.68-3.5a.51.51,0,0,1,.69,0l3.76,3.46a.69.69,0,0,1,.13.2l1.28,3.45a.5.5,0,0,1-.09.51c-2.77,3.18-3.17,3.28-3.32,3.32l-.28.08A10.15,10.15,0,0,1,386.66,383.83Zm-4-4.18c1.66,1.46,3.47,3,3.79,3.16.14.05.63.07,2.4-.44a1.83,1.83,0,0,1,.32-.09c.21-.14,1.5-1.52,2.61-2.79l-1.14-3.06-3.32-3.06c-1.16,1.13-3.21,3.1-3.49,3.28C383.72,376.83,383.15,378.29,382.66,379.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,385.34a.45.45,0,0,1-.16,0l-4.45-1.58a.5.5,0,0,1-.33-.53.49.49,0,0,1,.44-.44l3.54-.37,2.08-2.87-1.15-3.09L387,373.05a.5.5,0,0,1-.15-.45.48.48,0,0,1,.29-.37l4.34-2a.5.5,0,0,1,.56.09l2.87,2.77.08.1,2.37,4a.51.51,0,0,1,.07.32l-.4,3.06a.49.49,0,0,1-.08.21l-2,3.06a.53.53,0,0,1-.26.21l-3.86,1.28A.41.41,0,0,1,390.67,385.34Zm-2.2-1.82,2.21.79,3.52-1.18,1.82-2.82.36-2.78-2.25-3.74-2.57-2.49-3.35,1.52,3.2,2.95a.69.69,0,0,1,.13.2l1.28,3.45a.49.49,0,0,1-.06.47l-2.37,3.26a.54.54,0,0,1-.36.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,383.48l-.89-.45,1.44-2.88.08-.89-1-2.86a.55.55,0,0,1,.07-.45.49.49,0,0,1,.4-.21l4.25-.1,0,1-3.57.08.77,2.32a.76.76,0,0,1,0,.21l-.1,1.08a.78.78,0,0,1,0,.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.24 361.53 394.58 369.48 395.43 371.61 398.69 373.73 404.79 375.44 408.62 372.17 407.92 366.64 407.77 364.51 408.48 363.38 403.8 360.4 402.24 361.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.79,375.94l-.13,0-6.1-1.71a.35.35,0,0,1-.14-.06L395.16,372a.43.43,0,0,1-.19-.23l-.85-2.13a.48.48,0,0,1,.1-.53l7.66-7.94.07-.06,1.56-1.14a.5.5,0,0,1,.56,0l4.68,3a.5.5,0,0,1,.16.68l-.63,1,.13,2,.71,5.5a.49.49,0,0,1-.17.44l-3.83,3.27A.55.55,0,0,1,404.79,375.94Zm-5.89-2.67,5.77,1.61,3.42-2.91-.67-5.27-.15-2.16a.51.51,0,0,1,.08-.29l.45-.72-4-2.53-1.25.91-7.41,7.68.68,1.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.15,373.62a.54.54,0,0,1-.22-.05c-.49-.24-4.74-2.3-5.12-2.52l.52-.86c.24.14,2.79,1.39,4.66,2.3l.93-1.28a.41.41,0,0,1,.22-.17l3.56-1.45-.62-2.22a.51.51,0,0,1,.09-.45l2.22-2.72.77.63-2.05,2.52.67,2.4a.49.49,0,0,1-.29.59l-3.85,1.57-1.09,1.5A.49.49,0,0,1,401.15,373.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.75,374.8a.4.4,0,0,1-.15,0L401,373.59l.31-.95,3.28,1.07,2.36-3-.69-3.38,1-.2.73,3.61a.51.51,0,0,1-.09.41l-2.73,3.46A.49.49,0,0,1,404.75,374.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.84,365.76l2.28.74,2.06,5.15s-.81,2.28-.95,2.57a37.07,37.07,0,0,1-3.9,2.28l-5.37.81s-2.36-.66-2.43-1-5.81-2.79-5.81-2.79l1.71-1.88,3.26,2.12,6.1,1.71,3.83-3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,377.81a.34.34,0,0,1-.14,0c-2.13-.6-2.6-1-2.73-1.25a56,56,0,0,0-5.57-2.59.5.5,0,0,1-.29-.36.48.48,0,0,1,.12-.44l1.71-1.88a.5.5,0,0,1,.65-.08l3.19,2.08,5.77,1.61,3.42-2.91-.74-6.15a.48.48,0,0,1,.17-.44.5.5,0,0,1,.48-.09l2.28.73a.52.52,0,0,1,.31.29l2.06,5.15a.53.53,0,0,1,0,.35c-.13.39-.82,2.33-1,2.64-.07.15-.22.43-4.11,2.5l-.16.05-5.37.81Zm-2-1.76a9.72,9.72,0,0,0,2,.75l5.18-.78c1.57-.83,3.3-1.81,3.64-2.08.12-.3.53-1.43.84-2.28l-1.9-4.76-1.32-.42.69,5.63a.49.49,0,0,1-.17.44l-3.83,3.27a.54.54,0,0,1-.46.1l-6.1-1.71a.35.35,0,0,1-.14-.06l-2.91-1.89-.95,1C399.11,375.25,399.83,375.76,400,376.05Zm0,.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,376.78l-.11-1,8.62-.93.76-1.79.94-2.75-2.29-3.4.83-.56,2.43,3.61a.49.49,0,0,1,.06.44l-1,3-.9,2.09a.5.5,0,0,1-.41.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.67 381.28 377.55 381.28 382.26 447.35 419.96 447.35 424.67 381.28",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,447.85h-37.7a.5.5,0,0,1-.5-.47l-4.71-66.07a.51.51,0,0,1,.13-.37.52.52,0,0,1,.37-.16h47.12a.51.51,0,0,1,.5.53l-4.72,66.07A.49.49,0,0,1,420,447.85Zm-37.23-1h36.76l4.64-65.07h-46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.01 390.49 424.67 381.28 377.55 381.28 378.21 390.49 424.01 390.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,391h-45.8a.51.51,0,0,1-.5-.47l-.66-9.21a.51.51,0,0,1,.13-.37.52.52,0,0,1,.37-.16h47.12a.51.51,0,0,1,.5.53l-.66,9.21A.51.51,0,0,1,424,391Zm-45.34-1h44.88l.58-8.21h-46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.34,387.67v-4.33a2.53,2.53,0,0,0-2.53-2.54H80.73a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.53H56.81A2.53,2.53,0,0,0,59.34,387.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.73,390.7H56.81a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5,2,2,0,0,0,2-2v-4.34a2,2,0,0,0-2-2,.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H80.73a3,3,0,0,1,3,3v4.34A3,3,0,0,1,80.73,390.7Zm-21.67-1H80.73a2,2,0,0,0,2-2v-4.34a2,2,0,0,0-2-2H59.06a3,3,0,0,1,.78,2v4.34A3,3,0,0,1,59.06,389.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,381.14l-.29-.19a.08.08,0,0,1,0-.15H56.81a2.53,2.53,0,0,1,2.53,2.54v4.33a2.53,2.53,0,0,1-2.53,2.53H35.26a.08.08,0,0,1,0-.15l.29-.19Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.81,390.7H35.26a.58.58,0,0,1-.56-.41.59.59,0,0,1,.24-.66l.06,0v-8.18l-.06,0a.59.59,0,0,1-.24-.66.58.58,0,0,1,.56-.41H56.81a3,3,0,0,1,3,3v4.34A3,3,0,0,1,56.81,390.7ZM36,389.7H56.81a2,2,0,0,0,2-2v-4.34a2,2,0,0,0-2-2H36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.11,381.14H58.87a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H37.11a1.61,1.61,0,0,1-1.61-1.61v-5.49A1.61,1.61,0,0,1,37.11,381.14Z",
    transform: "translate(94.37 771) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.26,390.36H35.5a.5.5,0,0,1-.5-.5v-8.72a.5.5,0,0,1,.5-.5H57.26a2.11,2.11,0,0,1,2.11,2.12v5.49A2.11,2.11,0,0,1,57.26,390.36Zm-21.26-1H57.26a1.11,1.11,0,0,0,1.11-1.11v-5.49a1.12,1.12,0,0,0-1.11-1.12H36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,368.88v-4.33A2.54,2.54,0,0,0,56.43,362H80.35a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.54H56.43A2.54,2.54,0,0,0,59,368.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.35,371.92H56.43a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5,2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2,.5.5,0,0,1,0-1H80.35a3,3,0,0,1,3,3v4.33A3,3,0,0,1,80.35,371.92Zm-21.67-1H80.35a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H58.68a3,3,0,0,1,.79,2v4.33A3,3,0,0,1,58.68,370.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.12,362.35l-.28-.18a.09.09,0,0,1,0-.16H56.43A2.54,2.54,0,0,1,59,364.55v4.33a2.54,2.54,0,0,1-2.54,2.54H34.88a.09.09,0,0,1,0-.16l.28-.19Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.43,371.92H34.88a.59.59,0,0,1-.32-1.08l.06,0v-8.18l-.06,0a.58.58,0,0,1,.32-1.07H56.43a3,3,0,0,1,3,3v4.33A3.05,3.05,0,0,1,56.43,371.92Zm-20.81-1H56.43a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H35.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.74,362.35H58.5a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H36.74a1.61,1.61,0,0,1-1.61-1.61V364A1.61,1.61,0,0,1,36.74,362.35Z",
    transform: "translate(93.62 733.43) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,371.57H35.12a.5.5,0,0,1-.5-.5v-8.72a.51.51,0,0,1,.5-.5H56.88A2.12,2.12,0,0,1,59,364v5.49A2.12,2.12,0,0,1,56.88,371.57Zm-21.26-1H56.88A1.12,1.12,0,0,0,58,369.46V364a1.12,1.12,0,0,0-1.12-1.12H35.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.35,378.22v-4.34a2.53,2.53,0,0,0-2.54-2.53H84.74a2.54,2.54,0,0,1,2.54,2.53v4.34a2.54,2.54,0,0,1-2.54,2.53H60.81A2.53,2.53,0,0,0,63.35,378.22Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.74,381.25H60.81a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5,2,2,0,0,0,2-2v-4.34a2,2,0,0,0-2-2,.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H84.74a3,3,0,0,1,3,3v4.34A3,3,0,0,1,84.74,381.25Zm-21.67-1H84.74a2,2,0,0,0,2-2v-4.34a2,2,0,0,0-2-2H63.07a3.05,3.05,0,0,1,.78,2v4.34A3.05,3.05,0,0,1,63.07,380.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.51,371.69l-.29-.19a.08.08,0,0,1,.05-.15H60.81a2.53,2.53,0,0,1,2.54,2.53v4.34a2.53,2.53,0,0,1-2.54,2.53H39.27a.08.08,0,0,1-.05-.15l.29-.19Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.81,381.25H39.27a.58.58,0,0,1-.32-1.07l.06,0V372l-.06,0a.58.58,0,0,1,.32-1.07H60.81a3,3,0,0,1,3,3v4.34A3,3,0,0,1,60.81,381.25Zm-20.8-1h20.8a2,2,0,0,0,2-2v-4.34a2,2,0,0,0-2-2H40Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.12,371.69H62.88a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H41.12a1.61,1.61,0,0,1-1.61-1.61V373.3A1.61,1.61,0,0,1,41.12,371.69Z",
    transform: "translate(102.39 752.1) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27,380.91H39.51a.5.5,0,0,1-.5-.5v-8.72a.5.5,0,0,1,.5-.5H61.27a2.12,2.12,0,0,1,2.11,2.11v5.49A2.12,2.12,0,0,1,61.27,380.91Zm-21.26-1H61.27a1.12,1.12,0,0,0,1.11-1.12V373.3a1.11,1.11,0,0,0-1.11-1.11H40Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.51 385.76 45.44 383.83 47.37 385.76 47.37 374.74 43.51 374.74 43.51 385.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.37,386.26a.54.54,0,0,1-.36-.14l-1.57-1.58-1.58,1.58a.5.5,0,0,1-.85-.36v-11a.5.5,0,0,1,.5-.5h3.86a.51.51,0,0,1,.5.5v11a.49.49,0,0,1-.31.46A.43.43,0,0,1,47.37,386.26Zm-3.36-11v9.32l1.08-1.08a.47.47,0,0,1,.35-.15h0a.47.47,0,0,1,.35.15l1.08,1.07v-9.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.87,
    y: 364.78,
    width: 26.58,
    height: 30.96,
    transform: "translate(-47.92 13.49) rotate(-7.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,397.82a.5.5,0,0,1-.49-.44l-4-30.71a.5.5,0,0,1,.1-.37.53.53,0,0,1,.33-.19l26.36-3.4a.49.49,0,0,1,.56.44l4,30.71a.5.5,0,0,1-.1.37.53.53,0,0,1-.33.19L70,397.81ZM66.57,367l3.82,29.72,25.37-3.27-3.82-29.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 364.37,
    width: 24.28,
    height: 30.96,
    transform: "translate(-47.84 13.89) rotate(-7.34)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,397.26a.5.5,0,0,1-.49-.44l-4-30.71a.55.55,0,0,1,.1-.37.53.53,0,0,1,.33-.19l24.09-3.1a.5.5,0,0,1,.56.43l4,30.71a.55.55,0,0,1-.1.37.58.58,0,0,1-.34.19l-24.08,3.1Zm-3.39-30.78,3.83,29.72,23.09-3L94,363.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.09,
    y: 384.41,
    width: 71.42,
    height: 62.54,
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,447.45H29.09a.51.51,0,0,1-.5-.5V384.41a.5.5,0,0,1,.5-.5h71.42a.5.5,0,0,1,.5.5V447A.51.51,0,0,1,100.51,447.45Zm-70.92-1H100V384.91H29.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.29,
    y: 384.41,
    width: 22.22,
    height: 62.54,
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,447.45H78.29a.5.5,0,0,1-.5-.5V384.41a.5.5,0,0,1,.5-.5h22.22a.5.5,0,0,1,.5.5V447A.51.51,0,0,1,100.51,447.45Zm-21.72-1H100V384.91H78.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lamp-2--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.34,91.45a39.37,39.37,0,0,0-76.65,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.34,92H214.69a.49.49,0,0,1-.39-.19.51.51,0,0,1-.1-.43,39.88,39.88,0,0,1,77.63,0,.51.51,0,0,1-.1.43A.49.49,0,0,1,291.34,92Zm-76-1H290.7a38.87,38.87,0,0,0-75.37,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.49,83.5a39,39,0,0,0-2.8,8h76.65a39,39,0,0,0-2.8-8Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.34,92H214.69a.49.49,0,0,1-.39-.19.51.51,0,0,1-.1-.43,40.14,40.14,0,0,1,2.84-8,.5.5,0,0,1,.45-.28h71.05a.5.5,0,0,1,.45.28,40.14,40.14,0,0,1,2.84,8,.51.51,0,0,1-.1.43A.49.49,0,0,1,291.34,92Zm-76-1H290.7a38.36,38.36,0,0,0-2.48-7H217.81A38.64,38.64,0,0,0,215.33,91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,62.1a1,1,0,0,1-1-1V13.65a1,1,0,0,1,2,0V61.1A1,1,0,0,1,253,62.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelves-2--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.18,291.15v-4.33a2.53,2.53,0,0,0-2.54-2.54h23.93a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.53H458.64A2.53,2.53,0,0,0,461.18,291.15Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.57,294.18H458.64a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5,2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2,.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.93a3,3,0,0,1,3,3v4.33A3,3,0,0,1,482.57,294.18Zm-21.68-1h21.68a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H460.9a3.06,3.06,0,0,1,.78,2v4.33A3,3,0,0,1,460.89,293.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.34,284.62l-.29-.19a.08.08,0,0,1,.05-.15h21.54a2.53,2.53,0,0,1,2.54,2.54v4.33a2.53,2.53,0,0,1-2.54,2.53H437.1a.08.08,0,0,1-.05-.15l.29-.19Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.64,294.18H437.1a.58.58,0,0,1-.32-1.07l.06,0v-8.18l-.06,0a.56.56,0,0,1-.24-.65.58.58,0,0,1,.56-.42h21.54a3,3,0,0,1,3,3v4.33A3,3,0,0,1,458.64,294.18Zm-21.31-.24h0Zm.51-.76h20.8a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2h-20.8Zm-.51-9.17h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,284.62h21.76a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H439a1.61,1.61,0,0,1-1.61-1.61v-5.49A1.61,1.61,0,0,1,439,284.62Z",
    transform: "translate(898.05 577.96) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.1,293.84H437.34a.5.5,0,0,1-.5-.5v-8.72a.5.5,0,0,1,.5-.5H459.1a2.12,2.12,0,0,1,2.11,2.12v5.49A2.12,2.12,0,0,1,459.1,293.84Zm-21.26-1H459.1a1.11,1.11,0,0,0,1.11-1.11v-5.49a1.12,1.12,0,0,0-1.11-1.12H437.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.68,281.54v-4.33a2.54,2.54,0,0,0-2.53-2.54h23.92a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.54H460.15A2.54,2.54,0,0,0,462.68,281.54Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.07,284.58H460.15a.5.5,0,0,1,0-1,2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2,.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.92a3,3,0,0,1,3,3v4.33A3,3,0,0,1,484.07,284.58Zm-21.67-1h21.67a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H462.4a3.08,3.08,0,0,1,.78,2v4.33A3.06,3.06,0,0,1,462.4,283.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.84,275l-.29-.19a.09.09,0,0,1,.05-.16h21.55a2.54,2.54,0,0,1,2.53,2.54v4.33a2.54,2.54,0,0,1-2.53,2.54H438.6a.09.09,0,0,1-.05-.16l.29-.18Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.15,284.58H438.6a.59.59,0,0,1-.56-.42.57.57,0,0,1,.24-.65l.06,0v-8.18l-.06,0a.59.59,0,0,1,.32-1.08h21.55a3,3,0,0,1,3,3v4.33A3,3,0,0,1,460.15,284.58Zm-20.81-1h20.81a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H439.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.45,275h21.76a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H440.45a1.61,1.61,0,0,1-1.61-1.61v-5.49A1.61,1.61,0,0,1,440.45,275Z",
    transform: "translate(901.05 558.75) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.6,284.24H438.84a.5.5,0,0,1-.5-.5V275a.5.5,0,0,1,.5-.5H460.6a2.12,2.12,0,0,1,2.11,2.11v5.49A2.12,2.12,0,0,1,460.6,284.24Zm-21.26-1H460.6a1.12,1.12,0,0,0,1.11-1.12v-5.49a1.11,1.11,0,0,0-1.11-1.11H439.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.68 231.75 453.58 226.29 459.82 229.8 454.17 215.57 460.21 224.73 459.63 208.17 463.33 222 465.47 212.06 466.06 223.95 470.15 219.28 468.2 228.04 471.32 225.9 467.23 232.72 457.68 231.75",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.22,233.22h-.05l-9.54-1a.48.48,0,0,1-.35-.19l-4.1-5.46a.5.5,0,0,1,.65-.74l5,2.82-5.13-12.91a.51.51,0,0,1,.24-.63.5.5,0,0,1,.65.17l5.06,7.67-.52-14.78a.5.5,0,0,1,.42-.52.51.51,0,0,1,.56.37l3.17,11.83L465,212a.51.51,0,0,1,.53-.39.5.5,0,0,1,.46.47l.52,10.65,3.28-3.74a.5.5,0,0,1,.87.43L469,226.91l2.07-1.42a.5.5,0,0,1,.72.67l-4.1,6.82A.5.5,0,0,1,467.22,233.22Zm-9.28-1.95,9,.92,2.75-4.57-1.23.84a.52.52,0,0,1-.56,0,.51.51,0,0,1-.21-.52l1.52-6.86-2.8,3.2a.48.48,0,0,1-.54.14.48.48,0,0,1-.33-.44l-.4-8.09-1.34,6.22a.5.5,0,0,1-.48.39h0a.5.5,0,0,1-.49-.37l-2.56-9.58.43,12.16a.5.5,0,0,1-.92.3l-3.36-5.1,3.85,9.7a.49.49,0,0,1-.13.56.5.5,0,0,1-.58.06l-4.16-2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.64,
    y: 231.8,
    width: 16.33,
    height: 12.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,244.73H454.64a.5.5,0,0,1-.5-.5V231.8a.5.5,0,0,1,.5-.5H471a.5.5,0,0,1,.5.5v12.43A.5.5,0,0,1,471,244.73Zm-15.83-1h15.33V232.3H455.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.88,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,145.94h-8.85a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,406.73,145.94Zm-8.35-1h7.85V105.06h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.88,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,111.38h-8.85a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,406.73,111.38Zm-8.35-1h7.85v-3.64h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.88,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,143.41h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,406.73,143.41Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.57,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,145.94h-8.86a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,416.43,145.94Zm-8.36-1h7.86V105.06h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.57,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,111.38h-8.86a.5.5,0,0,1-.5-.5v-4.64a.51.51,0,0,1,.5-.5h8.86a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,416.43,111.38Zm-8.36-1h7.86v-3.64h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.57,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.43,143.41h-8.86a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,416.43,143.41Zm-8.36-1h7.86v-3.63h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.27,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.12,145.94h-8.85a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,426.12,145.94Zm-8.35-1h7.85V105.06h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.27,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.12,111.38h-8.85a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,426.12,111.38Zm-8.35-1h7.85v-3.64h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.27,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.12,143.41h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,426.12,143.41Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.81,145.94H427a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,435.81,145.94Zm-8.35-1h7.85V105.06h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.81,111.38H427a.5.5,0,0,1-.5-.5v-4.64a.51.51,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,435.81,111.38Zm-8.35-1h7.85v-3.64h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.81,143.41H427a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,435.81,143.41Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.66,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.51,145.94h-8.85a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,445.51,145.94Zm-8.35-1H445V105.06h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.66,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.51,111.38h-8.85a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,445.51,111.38Zm-8.35-1H445v-3.64h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.66,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.51,143.41h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,445.51,143.41Zm-8.35-1H445v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.91,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.76,145.94h-8.85a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,454.76,145.94Zm-8.35-1h7.85V105.06h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.91,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.76,111.38h-8.85a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,454.76,111.38Zm-8.35-1h7.85v-3.64h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.91,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.76,143.41h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,454.76,143.41Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.6,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,145.94H455.6a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,464.45,145.94Zm-8.35-1H464V105.06H456.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.6,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,111.38H455.6a.5.5,0,0,1-.5-.5v-4.64a.51.51,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,464.45,111.38Zm-8.35-1H464v-3.64H456.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.6,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45,143.41H455.6a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,464.45,143.41Zm-8.35-1H464v-3.63H456.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.3,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.15,145.94H465.3a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,474.15,145.94Zm-8.35-1h7.85V105.06H465.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.3,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.15,111.38H465.3a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,474.15,111.38Zm-8.35-1h7.85v-3.64H465.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.3,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.15,143.41H465.3a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,474.15,143.41Zm-8.35-1h7.85v-3.63H465.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.75,
    y: 145.11,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.81,150.06H391.75a.5.5,0,0,1-.5-.5V145.1a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.46A.5.5,0,0,1,488.81,150.06Zm-96.56-1h96.06V145.6H392.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.54,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(881.92 349.12) rotate(180)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.39,195.5h-8.85a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,445.39,195.5Zm-8.35-1h7.85V154.62H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.54,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.39,160.94h-8.85a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5h8.85a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,445.39,160.94Zm-8.35-1h7.85V156.3H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.54,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.39,193h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,445.39,193ZM437,192h7.85v-3.63H437Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.84,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(862.53 349.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.69,195.5h-8.85a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,435.69,195.5Zm-8.35-1h7.85V154.62h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.84,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.69,160.94h-8.85a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,435.69,160.94Zm-8.35-1h7.85V156.3h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.84,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.69,193h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,435.69,193Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.15,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(843.15 349.12) rotate(180)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,195.5h-8.85a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5H426a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,426,195.5Zm-8.35-1h7.85V154.62h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.15,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,160.94h-8.85a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5H426a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,426,160.94Zm-8.35-1h7.85V156.3h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.15,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,193h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5H426a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,426,193Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.27,
    y: 153.68,
    width: 8.85,
    height: 40.89,
    transform: "translate(752.77 452.43) rotate(-164.24)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.4,195.5a.34.34,0,0,1-.14,0l-8.52-2.4a.5.5,0,0,1-.34-.62l11.1-39.35a.54.54,0,0,1,.24-.3.5.5,0,0,1,.38,0l8.52,2.4a.5.5,0,0,1,.34.62l-11.1,39.35A.49.49,0,0,1,406.4,195.5Zm-7.9-3.25,7.55,2.14L416.89,156l-7.56-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.84,
    y: 153.88,
    width: 4.64,
    height: 8.85,
    transform: "translate(147.86 511.97) rotate(-74.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.79,162.24l-.14,0-8.52-2.4a.51.51,0,0,1-.3-.24.5.5,0,0,1,0-.38l1.26-4.46a.5.5,0,0,1,.61-.35l8.52,2.41a.47.47,0,0,1,.3.23.51.51,0,0,1,0,.38l-1.26,4.47A.51.51,0,0,1,415.79,162.24ZM407.88,159l7.56,2.13,1-3.5-7.56-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.14,
    y: 184.71,
    width: 4.64,
    height: 8.85,
    transform: "translate(111.85 526.05) rotate(-74.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.09,193.07l-.14,0-8.52-2.4a.5.5,0,0,1-.34-.62l1.25-4.46a.48.48,0,0,1,.24-.3.51.51,0,0,1,.38-.05l8.52,2.41a.47.47,0,0,1,.3.23.51.51,0,0,1,.05.38l-1.26,4.47A.51.51,0,0,1,407.09,193.07Zm-7.91-3.25,7.56,2.13,1-3.5-7.56-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.74,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(958.33 349.12) rotate(180)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.59,195.5h-8.85a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,483.59,195.5Zm-8.35-1h7.85V154.62h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.74,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.59,160.94h-8.85a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5h8.85a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,483.59,160.94Zm-8.35-1h7.85V156.3h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.74,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.59,193h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,483.59,193Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.04,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(938.94 349.12) rotate(180)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.89,195.5H465a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,473.89,195.5Zm-8.35-1h7.85V154.62h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.04,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.89,160.94H465a.5.5,0,0,1-.5-.5V155.8a.51.51,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,473.89,160.94Zm-8.35-1h7.85V156.3h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.04,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.89,193H465a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,473.89,193Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.16,
    y: 153.68,
    width: 8.85,
    height: 40.89,
    transform: "translate(846.76 465.44) rotate(-164.24)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.29,195.5a.3.3,0,0,1-.13,0l-8.52-2.4a.48.48,0,0,1-.3-.24.5.5,0,0,1,0-.38l11.11-39.35a.5.5,0,0,1,.24-.3.5.5,0,0,1,.38,0l8.51,2.4a.5.5,0,0,1,.35.62l-11.1,39.35A.51.51,0,0,1,454.29,195.5Zm-7.9-3.25,7.56,2.14L464.78,156l-7.55-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.73,
    y: 153.88,
    width: 4.64,
    height: 8.85,
    transform: "translate(182.75 558.07) rotate(-74.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.68,162.24l-.13,0-8.52-2.4a.48.48,0,0,1-.3-.24.46.46,0,0,1-.05-.38l1.26-4.46a.51.51,0,0,1,.62-.35l8.52,2.41a.52.52,0,0,1,.3.23.51.51,0,0,1,0,.38l-1.26,4.47A.49.49,0,0,1,463.68,162.24Zm-7.9-3.25,7.56,2.13,1-3.5-7.55-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.03,
    y: 184.71,
    width: 4.64,
    height: 8.85,
    transform: "translate(146.73 572.15) rotate(-74.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455,193.07l-.14,0-8.51-2.4A.51.51,0,0,1,446,190l1.26-4.46a.48.48,0,0,1,.24-.3.5.5,0,0,1,.38-.05l8.52,2.41a.52.52,0,0,1,.3.23.51.51,0,0,1,0,.38l-1.26,4.47A.49.49,0,0,1,455,193.07Zm-7.9-3.25,7.55,2.13,1-3.5-7.55-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.75,
    y: 194.67,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.81,199.62H391.75a.5.5,0,0,1-.5-.5v-4.45a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.45A.5.5,0,0,1,488.81,199.62Zm-96.56-1h96.06v-3.45H392.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.9,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.75,245.06H396.9a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,405.75,245.06Zm-8.35-1h7.85V204.18H397.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.9,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.75,210.5H396.9a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,405.75,210.5Zm-8.35-1h7.85v-3.63H397.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.9,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.75,242.54H396.9a.5.5,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V242A.51.51,0,0,1,405.75,242.54Zm-8.35-1h7.85V237.9H397.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.59,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,245.06h-8.85a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,415.44,245.06Zm-8.35-1h7.85V204.18h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.59,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,210.5h-8.85a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,415.44,210.5Zm-8.35-1h7.85v-3.63h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.59,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,242.54h-8.85a.5.5,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V242A.5.5,0,0,1,415.44,242.54Zm-8.35-1h7.85V237.9h-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.28,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.14,245.06h-8.86a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,425.14,245.06Zm-8.36-1h7.86V204.18h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.28,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.14,210.5h-8.86a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,425.14,210.5Zm-8.36-1h7.86v-3.63h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.28,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.14,242.54h-8.86a.51.51,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5V242A.51.51,0,0,1,425.14,242.54Zm-8.36-1h7.86V237.9h-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.21,
    y: 203.5,
    width: 8.85,
    height: 40.89,
    transform: "translate(-7.93 15.97) rotate(-2.1)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,245a.5.5,0,0,1-.5-.48L425,203.69a.5.5,0,0,1,.48-.51l8.85-.33a.49.49,0,0,1,.36.13.57.57,0,0,1,.16.35l1.5,40.86a.5.5,0,0,1-.14.36.48.48,0,0,1-.34.16L427,245Zm-1-40.87L427.44,244l7.85-.29-1.46-39.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.61,
    y: 205.2,
    width: 8.85,
    height: 4.64,
    transform: "translate(-7.33 15.94) rotate(-2.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.69,210.49a.5.5,0,0,1-.34-.13.54.54,0,0,1-.16-.35l-.17-4.63a.5.5,0,0,1,.49-.52l8.84-.32a.49.49,0,0,1,.36.13.5.5,0,0,1,.16.35l.17,4.63a.5.5,0,0,1-.48.52l-8.85.32Zm.35-4.65.13,3.64,7.85-.29-.13-3.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.78,
    y: 237.21,
    width: 8.85,
    height: 4.64,
    transform: "translate(-8.51 16) rotate(-2.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.87,242.51a.5.5,0,0,1-.5-.48l-.17-4.64a.49.49,0,0,1,.13-.36.57.57,0,0,1,.35-.16l8.85-.32h0a.51.51,0,0,1,.5.48l.17,4.63a.52.52,0,0,1-.14.36.46.46,0,0,1-.35.16l-8.84.33Zm.35-4.66.13,3.64,7.85-.29-.14-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.73,
    y: 203.48,
    width: 8.85,
    height: 40.89,
    transform: "translate(12.23 -22.67) rotate(2.98)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.51,245.06h0l-8.84-.46a.5.5,0,0,1-.47-.52l2.12-40.83a.51.51,0,0,1,.53-.48l8.84.46a.5.5,0,0,1,.47.53L446,244.59a.53.53,0,0,1-.17.35A.5.5,0,0,1,445.51,245.06Zm-8.31-1.43L445,244l2.07-39.83-7.84-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.69,
    y: 203.08,
    width: 4.64,
    height: 8.85,
    transform: "translate(212.77 639.13) rotate(-87.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.3,210.55h0l-8.84-.46a.53.53,0,0,1-.35-.17.52.52,0,0,1-.12-.36l.24-4.63a.49.49,0,0,1,.52-.47l8.84.46a.49.49,0,0,1,.47.52l-.24,4.63a.46.46,0,0,1-.16.35A.51.51,0,0,1,447.3,210.55ZM439,209.12l7.84.4.19-3.63-7.84-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.02,
    y: 235.07,
    width: 4.64,
    height: 8.85,
    transform: "translate(179.24 667.8) rotate(-87.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.64,242.54h0l-8.84-.46a.51.51,0,0,1-.34-.17.5.5,0,0,1-.13-.36l.24-4.63a.5.5,0,0,1,.53-.47l8.84.46a.54.54,0,0,1,.34.16.5.5,0,0,1,.13.37l-.24,4.62A.5.5,0,0,1,445.64,242.54Zm-8.31-1.43,7.84.4.19-3.63-7.84-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.75,
    y: 244.23,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.81,249.18H391.75a.5.5,0,0,1-.5-.5v-4.45a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.45A.5.5,0,0,1,488.81,249.18Zm-96.56-1h96.06v-3.45H392.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.75,
    y: 293.79,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.81,298.74H391.75a.5.5,0,0,1-.5-.5v-4.45a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.45A.5.5,0,0,1,488.81,298.74Zm-96.56-1h96.06v-3.45H392.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.3 278.56 435.43 293.59 425.38 293.59 430.3 278.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.43,294.09H425.38a.49.49,0,0,1-.41-.21.52.52,0,0,1-.07-.45l4.92-15a.51.51,0,0,1,.48-.34h0a.5.5,0,0,1,.47.33l5.13,15a.48.48,0,0,1-.06.45A.52.52,0,0,1,435.43,294.09Zm-9.36-1h8.66l-4.42-12.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.48 264.27 411.66 264.27 402.54 293.22 426.36 293.22 435.48 264.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.36,293.72H402.54a.48.48,0,0,1-.4-.2.52.52,0,0,1-.08-.45l9.12-28.95a.52.52,0,0,1,.48-.35h23.82a.49.49,0,0,1,.4.21.49.49,0,0,1,.07.44l-9.11,28.95A.5.5,0,0,1,426.36,293.72Zm-23.14-1H426l8.81-28H412Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.94 266.51 412.79 266.51 405.08 290.99 425.23 290.99 432.94 266.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.23,291.49H405.08a.51.51,0,0,1-.4-.2.52.52,0,0,1-.08-.45l7.72-24.48a.48.48,0,0,1,.47-.35h20.15a.48.48,0,0,1,.4.2.51.51,0,0,1,.07.45l-7.71,24.48A.49.49,0,0,1,425.23,291.49Zm-19.47-1h19.1l7.4-23.48h-19.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelves-1--inject-403"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,145.94H23.76a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,32.61,145.94Zm-8.35-1h7.85V105.06H24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,111.38H23.76a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,32.61,111.38Zm-8.35-1h7.85v-3.64H24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,143.41H23.76a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,32.61,143.41Zm-8.35-1h7.85v-3.63H24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.31,145.94H33.45a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,42.31,145.94Zm-8.36-1h7.86V105.06H34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.31,111.38H33.45a.5.5,0,0,1-.5-.5v-4.64a.51.51,0,0,1,.5-.5h8.86a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,42.31,111.38Zm-8.36-1h7.86v-3.64H34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.31,143.41H33.45a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,42.31,143.41Zm-8.36-1h7.86v-3.63H34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,145.94H43.15a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5H52a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,52,145.94Zm-8.35-1H51.5V105.06H43.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,111.38H43.15a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5H52a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,52,111.38Zm-8.35-1H51.5v-3.64H43.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,143.41H43.15a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5H52a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,52,143.41Zm-8.35-1H51.5v-3.63H43.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,145.94H52.84a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,61.69,145.94Zm-8.35-1h7.85V105.06H53.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,111.38H52.84a.5.5,0,0,1-.5-.5v-4.64a.51.51,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,61.69,111.38Zm-8.35-1h7.85v-3.64H53.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,143.41H52.84a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,61.69,143.41Zm-8.35-1h7.85v-3.63H53.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.54,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,145.94H62.54a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,71.39,145.94Zm-8.35-1h7.85V105.06H63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.54,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,111.38H62.54a.5.5,0,0,1-.5-.5v-4.64a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,71.39,111.38Zm-8.35-1h7.85v-3.64H63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.54,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,143.41H62.54a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,71.39,143.41Zm-8.35-1h7.85v-3.63H63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 104.56,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,145.94H72.23a.5.5,0,0,1-.5-.5V104.56a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,81.08,145.94Zm-8.35-1h7.85V105.06H72.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 106.24,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,111.38H72.23a.5.5,0,0,1-.5-.5v-4.64a.51.51,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,81.08,111.38Zm-8.35-1h7.85v-3.64H72.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 138.28,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,143.41H72.23a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,81.08,143.41Zm-8.35-1h7.85v-3.63H72.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.11,
    y: 104.12,
    width: 8.85,
    height: 40.89,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, -30.43, 29.27)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.83,145.94a.5.5,0,0,1-.24-.06.51.51,0,0,1-.24-.3l-11.1-39.35a.5.5,0,0,1,0-.38.51.51,0,0,1,.3-.24l8.52-2.4a.5.5,0,0,1,.62.34l11.1,39.35a.5.5,0,0,1-.34.62L92,145.92A.34.34,0,0,1,91.83,145.94Zm-10.49-39.5,10.84,38.39,7.55-2.14L88.9,104.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.65,
    y: 106.43,
    width: 8.85,
    height: 4.64,
    transform: "translate(-26.3 27.47) rotate(-15.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.44,112.68a.44.44,0,0,1-.24-.07.52.52,0,0,1-.24-.3l-1.26-4.46a.51.51,0,0,1,0-.38.52.52,0,0,1,.3-.24l8.52-2.4a.51.51,0,0,1,.62.35l1.25,4.46a.5.5,0,0,1,0,.38.52.52,0,0,1-.3.24l-8.52,2.4Zm-.64-4.62,1,3.5,7.56-2.13-1-3.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.35,
    y: 137.26,
    width: 8.85,
    height: 4.64,
    transform: "translate(-34.35 30.99) rotate(-15.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.15,143.51a.52.52,0,0,1-.49-.37l-1.26-4.46a.51.51,0,0,1,0-.38.52.52,0,0,1,.3-.24l8.52-2.4a.51.51,0,0,1,.62.35l1.26,4.46a.51.51,0,0,1-.35.62l-8.52,2.4Zm-.65-4.62,1,3.5,7.56-2.13-1-3.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.63,
    y: 145.11,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69,150.06H17.63a.5.5,0,0,1-.5-.5V145.1a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.46A.5.5,0,0,1,114.69,150.06Zm-96.56-1h96.06V145.6H18.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.96,
    y: 153.66,
    width: 8.85,
    height: 40.89,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 241.7, 317)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29,195.5a.5.5,0,0,1-.48-.37L90.42,155.59a.5.5,0,0,1,.06-.38.44.44,0,0,1,.3-.23l8.56-2.25a.5.5,0,0,1,.61.35l10.39,39.55a.49.49,0,0,1-.36.61l-8.56,2.25Zm-9.77-39.68,10.13,38.57,7.59-2L99.11,153.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.78,
    y: 155.89,
    width: 8.85,
    height: 4.64,
    transform: "translate(-37.04 29.63) rotate(-14.72)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.51,162.07a.49.49,0,0,1-.48-.37l-1.18-4.48a.55.55,0,0,1,.05-.38.48.48,0,0,1,.31-.23l8.56-2.25a.46.46,0,0,1,.38,0,.52.52,0,0,1,.23.3l1.18,4.49a.5.5,0,0,1-.36.61l-8.56,2.25ZM92,157.45l.92,3.51,7.59-2-.92-3.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.92,
    y: 186.87,
    width: 8.85,
    height: 4.64,
    transform: "translate(-44.64 32.71) rotate(-14.72)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.65,193.06a.5.5,0,0,1-.48-.38L99,188.2a.51.51,0,0,1,.05-.38.52.52,0,0,1,.31-.23l8.56-2.25a.49.49,0,0,1,.61.36l1.18,4.48a.5.5,0,0,1-.36.61L100.78,193Zm-.57-4.63L101,192l7.59-2-.92-3.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(172.46 349.12) rotate(180)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,195.5H81.8a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,90.66,195.5Zm-8.36-1h7.86V154.62H82.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,160.94H81.8a.5.5,0,0,1-.5-.5V155.8a.51.51,0,0,1,.5-.5h8.86a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,90.66,160.94Zm-8.36-1h7.86V156.3H82.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,193H81.8a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,90.66,193Zm-8.36-1h7.86v-3.63H82.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.11,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(153.07 349.12) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,195.5H72.11a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5H81a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,81,195.5Zm-8.35-1h7.85V154.62H72.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.11,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,160.94H72.11a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5H81a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,81,160.94Zm-8.35-1h7.85V156.3H72.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.11,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,193H72.11a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5H81a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,81,193Zm-8.35-1h7.85v-3.63H72.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.42,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(133.68 349.12) rotate(180)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,195.5H62.42a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,71.27,195.5Zm-8.35-1h7.85V154.62H62.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.42,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,160.94H62.42a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5h8.85a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,71.27,160.94Zm-8.35-1h7.85V156.3H62.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.42,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,193H62.42a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,71.27,193Zm-8.35-1h7.85v-3.63H62.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.72,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(114.29 349.12) rotate(180)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.57,195.5H52.72a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,61.57,195.5Zm-8.35-1h7.85V154.62H53.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.72,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.57,160.94H52.72a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,61.57,160.94Zm-8.35-1h7.85V156.3H53.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.72,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.57,193H52.72a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,61.57,193Zm-8.35-1h7.85v-3.63H53.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.03,
    y: 154.12,
    width: 8.85,
    height: 40.89,
    transform: "translate(94.9 349.12) rotate(180)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,195.5H43a.5.5,0,0,1-.5-.5V154.12a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V195A.5.5,0,0,1,51.88,195.5Zm-8.35-1h7.85V154.62H43.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.03,
    y: 155.8,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,160.94H43a.5.5,0,0,1-.5-.5V155.8a.5.5,0,0,1,.5-.5h8.85a.51.51,0,0,1,.5.5v4.64A.5.5,0,0,1,51.88,160.94Zm-8.35-1h7.85V156.3H43.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.03,
    y: 187.84,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,193H43a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,51.88,193Zm-8.35-1h7.85v-3.63H43.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.15,
    y: 153.68,
    width: 8.85,
    height: 40.89,
    transform: "translate(18.59 350.83) rotate(-164.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.28,195.5a.34.34,0,0,1-.14,0l-8.52-2.4a.54.54,0,0,1-.3-.24.5.5,0,0,1,0-.38l11.1-39.35a.54.54,0,0,1,.24-.3.5.5,0,0,1,.38,0l8.52,2.4a.5.5,0,0,1,.34.62l-11.1,39.35A.49.49,0,0,1,32.28,195.5Zm-7.9-3.25,7.55,2.14L42.77,156l-7.56-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.72,
    y: 153.88,
    width: 4.64,
    height: 8.85,
    transform: "translate(-124.65 151.92) rotate(-74.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.67,162.24l-.14,0L33,159.82a.51.51,0,0,1-.3-.24.5.5,0,0,1,0-.38l1.25-4.46a.52.52,0,0,1,.24-.3.51.51,0,0,1,.38-.05l8.52,2.41a.47.47,0,0,1,.3.23.51.51,0,0,1,0,.38l-1.26,4.47A.51.51,0,0,1,41.67,162.24ZM33.76,159l7.56,2.13,1-3.5-7.56-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.02,
    y: 184.71,
    width: 4.64,
    height: 8.85,
    transform: "translate(-160.66 166) rotate(-74.24)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,193.07l-.13,0-8.52-2.4A.52.52,0,0,1,24,190l1.26-4.46a.52.52,0,0,1,.24-.3.46.46,0,0,1,.38-.05l8.52,2.41a.5.5,0,0,1,.35.61l-1.26,4.47a.59.59,0,0,1-.24.3A.54.54,0,0,1,33,193.07Zm-7.9-3.25L32.62,192l1-3.5-7.56-2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.63,
    y: 194.67,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69,199.62H17.63a.5.5,0,0,1-.5-.5v-4.45a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.45A.5.5,0,0,1,114.69,199.62Zm-96.56-1h96.06v-3.45H18.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.78,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63,245.06H22.78a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,31.63,245.06Zm-8.35-1h7.85V204.18H23.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.78,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63,210.5H22.78a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,31.63,210.5Zm-8.35-1h7.85v-3.63H23.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.78,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63,242.54H22.78a.5.5,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V242A.51.51,0,0,1,31.63,242.54Zm-8.35-1h7.85V237.9H23.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.47,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.32,245.06H32.47a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,41.32,245.06Zm-8.35-1h7.85V204.18H33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.47,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.32,210.5H32.47a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,41.32,210.5Zm-8.35-1h7.85v-3.63H33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.47,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.32,242.54H32.47a.5.5,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V242A.5.5,0,0,1,41.32,242.54Zm-8.35-1h7.85V237.9H33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.16,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,245.06H42.16a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5H51a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,51,245.06Zm-8.36-1h7.86V204.18H42.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.16,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,210.5H42.16a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5H51a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,51,210.5Zm-8.36-1h7.86v-3.63H42.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.16,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,242.54H42.16a.51.51,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5H51a.5.5,0,0,1,.5.5V242A.51.51,0,0,1,51,242.54Zm-8.36-1h7.86V237.9H42.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.09,
    y: 203.5,
    width: 8.85,
    height: 40.89,
    transform: "translate(-8.19 2.23) rotate(-2.1)",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.84,245a.5.5,0,0,1-.5-.48l-1.5-40.86a.5.5,0,0,1,.48-.51l8.85-.33a.47.47,0,0,1,.36.13.57.57,0,0,1,.16.35l1.5,40.86a.54.54,0,0,1-.14.36.5.5,0,0,1-.34.16l-8.85.32Zm-1-40.87L53.32,244l7.85-.29-1.46-39.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.49,
    y: 205.2,
    width: 8.85,
    height: 4.64,
    transform: "translate(-7.58 2.19) rotate(-2.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.57,210.49a.5.5,0,0,1-.5-.48l-.17-4.63A.54.54,0,0,1,51,205a.5.5,0,0,1,.34-.16l8.85-.32a.5.5,0,0,1,.52.48l.17,4.63a.53.53,0,0,1-.13.36.54.54,0,0,1-.35.16l-8.85.32Zm.35-4.65.13,3.64,7.85-.29-.13-3.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.66,
    y: 237.21,
    width: 8.85,
    height: 4.64,
    transform: "translate(-8.76 2.26) rotate(-2.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.75,242.51a.48.48,0,0,1-.34-.14.5.5,0,0,1-.16-.34l-.17-4.64a.51.51,0,0,1,.48-.52l8.85-.32a.49.49,0,0,1,.51.48l.17,4.63A.47.47,0,0,1,62,242a.46.46,0,0,1-.35.16l-8.84.33Zm.35-4.66.13,3.64,7.85-.29-.14-3.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.61,
    y: 203.48,
    width: 8.85,
    height: 40.89,
    transform: "translate(11.72 -3.23) rotate(2.98)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,245.06h0l-8.84-.46a.5.5,0,0,1-.47-.52l2.12-40.83a.51.51,0,0,1,.53-.48l8.84.46a.5.5,0,0,1,.47.53l-2.12,40.83a.53.53,0,0,1-.17.35A.5.5,0,0,1,71.39,245.06Zm-8.31-1.43,7.84.41L73,204.21l-7.84-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.57,
    y: 203.08,
    width: 4.64,
    height: 8.85,
    transform: "translate(-141.92 265.52) rotate(-87.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.18,210.55h0l-8.84-.46a.5.5,0,0,1-.47-.53l.24-4.63a.46.46,0,0,1,.16-.34.49.49,0,0,1,.36-.13l8.84.46a.49.49,0,0,1,.47.52l-.24,4.63a.46.46,0,0,1-.16.35A.51.51,0,0,1,73.18,210.55Zm-8.31-1.43,7.84.4.19-3.63-7.84-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.9,
    y: 235.07,
    width: 4.64,
    height: 8.85,
    transform: "translate(-175.44 294.19) rotate(-87.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.52,242.54h0l-8.83-.46a.51.51,0,0,1-.35-.17.46.46,0,0,1-.13-.36l.24-4.63a.51.51,0,0,1,.17-.34.49.49,0,0,1,.36-.13l8.84.46a.5.5,0,0,1,.47.53L72,242.06A.5.5,0,0,1,71.52,242.54Zm-8.31-1.43,7.84.4.19-3.63-7.84-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.88,
    y: 203.68,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.73,245.06H73.88a.5.5,0,0,1-.5-.5V203.68a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.88A.5.5,0,0,1,82.73,245.06Zm-8.35-1h7.85V204.18H74.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.88,
    y: 205.37,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.73,210.5H73.88a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V210A.5.5,0,0,1,82.73,210.5Zm-8.35-1h7.85v-3.63H74.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.88,
    y: 237.4,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.73,242.54H73.88a.5.5,0,0,1-.5-.5V237.4a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5V242A.5.5,0,0,1,82.73,242.54Zm-8.35-1h7.85V237.9H74.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.76,
    y: 203.25,
    width: 8.85,
    height: 40.89,
    transform: "translate(-57.29 33.44) rotate(-15.76)",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,245.06a.54.54,0,0,1-.25-.06.47.47,0,0,1-.23-.3L81.89,205.35a.51.51,0,0,1,0-.38.52.52,0,0,1,.3-.24l8.52-2.4a.49.49,0,0,1,.61.35L102.48,242a.5.5,0,0,1-.35.62l-8.52,2.41ZM83,205.56,93.82,244l7.56-2.13L90.55,203.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.29,
    y: 205.55,
    width: 8.85,
    height: 4.64,
    transform: "translate(-53.16 31.64) rotate(-15.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,211.8a.48.48,0,0,1-.24-.06.5.5,0,0,1-.24-.3L82.35,207a.51.51,0,0,1,0-.38.52.52,0,0,1,.3-.23L91.21,204a.5.5,0,0,1,.62.35l1.26,4.46a.5.5,0,0,1,0,.38.53.53,0,0,1-.31.24l-8.51,2.4Zm-.64-4.62,1,3.5L92,208.55l-1-3.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.99,
    y: 236.38,
    width: 8.85,
    height: 4.64,
    transform: "translate(-61.21 35.16) rotate(-15.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.79,242.63a.5.5,0,0,1-.48-.36l-1.26-4.47a.51.51,0,0,1,0-.38.52.52,0,0,1,.31-.23l8.51-2.41a.5.5,0,0,1,.38.05.45.45,0,0,1,.24.3l1.26,4.46a.51.51,0,0,1-.35.62l-8.51,2.4ZM92.15,238l1,3.5,7.55-2.13-1-3.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.63,
    y: 244.23,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69,249.18H17.63a.5.5,0,0,1-.5-.5v-4.45a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.45A.5.5,0,0,1,114.69,249.18Zm-96.56-1h96.06v-3.45H18.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 253.24,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,294.63H23.76a.5.5,0,0,1-.5-.5V253.24a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.89A.5.5,0,0,1,32.61,294.63Zm-8.35-1h7.85V253.74H24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 254.93,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,260.06H23.76a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,32.61,260.06Zm-8.35-1h7.85v-3.63H24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.76,
    y: 286.96,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61,292.1H23.76a.5.5,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,32.61,292.1Zm-8.35-1h7.85v-3.64H24.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 253.24,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.31,294.63H33.45a.51.51,0,0,1-.5-.5V253.24a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v40.89A.51.51,0,0,1,42.31,294.63Zm-8.36-1h7.86V253.74H34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 254.93,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.31,260.06H33.45a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,42.31,260.06Zm-8.36-1h7.86v-3.63H34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.45,
    y: 286.96,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.31,292.1H33.45a.51.51,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h8.86a.5.5,0,0,1,.5.5v4.64A.51.51,0,0,1,42.31,292.1Zm-8.36-1h7.86v-3.64H34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 253.24,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,294.63H43.15a.5.5,0,0,1-.5-.5V253.24a.5.5,0,0,1,.5-.5H52a.5.5,0,0,1,.5.5v40.89A.5.5,0,0,1,52,294.63Zm-8.35-1H51.5V253.74H43.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 254.93,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,260.06H43.15a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5H52a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,52,260.06Zm-8.35-1H51.5v-3.63H43.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.15,
    y: 286.96,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,292.1H43.15a.5.5,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5H52a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,52,292.1Zm-8.35-1H51.5v-3.64H43.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 253.24,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,294.63H52.84a.51.51,0,0,1-.5-.5V253.24a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.89A.5.5,0,0,1,61.69,294.63Zm-8.35-1h7.85V253.74H53.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 254.93,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,260.06H52.84a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,61.69,260.06Zm-8.35-1h7.85v-3.63H53.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.84,
    y: 286.96,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.69,292.1H52.84a.51.51,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,61.69,292.1Zm-8.35-1h7.85v-3.64H53.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.54,
    y: 253.24,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,294.63H62.54a.5.5,0,0,1-.5-.5V253.24a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.89A.5.5,0,0,1,71.39,294.63Zm-8.35-1h7.85V253.74H63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.54,
    y: 254.93,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,260.06H62.54a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,71.39,260.06Zm-8.35-1h7.85v-3.63H63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.54,
    y: 286.96,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.39,292.1H62.54a.5.5,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,71.39,292.1Zm-8.35-1h7.85v-3.64H63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 253.24,
    width: 8.85,
    height: 40.89,
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,294.63H72.23a.51.51,0,0,1-.5-.5V253.24a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v40.89A.5.5,0,0,1,81.08,294.63Zm-8.35-1h7.85V253.74H72.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 254.93,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,260.06H72.23a.5.5,0,0,1-.5-.5v-4.63a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.63A.5.5,0,0,1,81.08,260.06Zm-8.35-1h7.85v-3.63H72.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 286.96,
    width: 8.85,
    height: 4.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.08,292.1H72.23a.51.51,0,0,1-.5-.5V287a.5.5,0,0,1,.5-.5h8.85a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,81.08,292.1Zm-8.35-1h7.85v-3.64H72.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.63,
    y: 293.79,
    width: 97.06,
    height: 4.45,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69,298.74H17.63a.5.5,0,0,1-.5-.5v-4.45a.5.5,0,0,1,.5-.5h97.06a.5.5,0,0,1,.5.5v4.45A.5.5,0,0,1,114.69,298.74Zm-96.56-1h96.06v-3.45H18.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.77,
    y: 282.29,
    width: 13.45,
    height: 11.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.23,294.14H85.77a.5.5,0,0,1-.5-.5V282.29a.5.5,0,0,1,.5-.5H99.23a.5.5,0,0,1,.5.5v11.35A.5.5,0,0,1,99.23,294.14Zm-13-1H98.73V282.79H86.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.82,277.43a5.54,5.54,0,0,0-2.3-1.61l-.26-1.06H99l-1.49-7.13a4.71,4.71,0,0,0-4.7-3.79s-2.69.05-3.11,2.37c-.1.54-.09,1.1-.16,1.65l-1.75,2.42,1.25.73c-.17,1.11-.22,2,.09,2.27A2.92,2.92,0,0,0,91,274s.69,1.16-1.15,1.85-3.23.92-3.69,2.3a19.49,19.49,0,0,0-.46,4.38H99.05S99.74,278.58,98.82,277.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.05,283H85.69a.51.51,0,0,1-.5-.5,19.74,19.74,0,0,1,.49-4.54c.46-1.38,1.68-1.8,3.1-2.29l.88-.32c.52-.19.84-.43.93-.7a.75.75,0,0,0,0-.2,3.19,3.19,0,0,1-1.82-.81c-.43-.43-.44-1.2-.28-2.37l-1-.56a.51.51,0,0,1-.24-.33.46.46,0,0,1,.09-.39l1.67-2.32c0-.19,0-.38,0-.57a8,8,0,0,1,.1-1,3.62,3.62,0,0,1,3.59-2.79,5.17,5.17,0,0,1,5.2,4.24l1.49,7.08a.5.5,0,0,1-.11.42.46.46,0,0,1-.38.18H96.9l0,.19a5.94,5.94,0,0,1,2.27,1.67h0c1,1.29.41,5,.34,5.46A.51.51,0,0,1,99.05,283ZM86.2,282H98.63c.21-1.46.32-3.61-.2-4.26a5.21,5.21,0,0,0-2.07-1.45.53.53,0,0,1-.33-.35l-.26-1.06a.49.49,0,0,1,.09-.42.49.49,0,0,1,.4-.2H98.4L97,267.74a4.25,4.25,0,0,0-4.17-3.4c-.12,0-2.32.08-2.66,2a8.55,8.55,0,0,0-.09.87q0,.38-.06.75a.5.5,0,0,1-.09.23l-1.43,2,.77.45a.49.49,0,0,1,.25.5c-.22,1.41-.13,1.77-.06,1.85a2.42,2.42,0,0,0,1.49.54.5.5,0,0,1,.43.25,1.54,1.54,0,0,1,.11,1.26A2.32,2.32,0,0,1,90,276.29l-.9.32c-1.43.5-2.19.8-2.48,1.67A16.17,16.17,0,0,0,86.2,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,274s2.34-.06,3-.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,274.47a.5.5,0,0,1-.5-.48.5.5,0,0,1,.49-.52,5,5,0,0,0,2.58-.62.51.51,0,0,1,.71-.06.49.49,0,0,1,.06.7c-.72.87-2.9,1-3.32,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86,276.25l.62,3.58s1.36-3.33,3.45-4.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,280.33h0a.5.5,0,0,1-.44-.41l-.62-3.57a.5.5,0,0,1,1-.17l.36,2.07a7.75,7.75,0,0,1,3-3.18.5.5,0,0,1,.67.24.5.5,0,0,1-.24.66c-1.9.89-3.19,4-3.21,4.06A.49.49,0,0,1,91.48,280.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86,265.53l3.21.74s.3,5.42.38,8.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.45,275.18a.51.51,0,0,1-.5-.49c-.07-2.49-.29-6.74-.36-8L90.75,266a.5.5,0,0,1-.37-.6A.5.5,0,0,1,91,265l3.2.74a.5.5,0,0,1,.39.46c0,.05.3,5.47.38,8.43a.5.5,0,0,1-.49.51Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures-2--inject-403"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.98,
    y: 127.71,
    width: 44.98,
    height: 51.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,180H341a.5.5,0,0,1-.5-.5V127.71a.5.5,0,0,1,.5-.5h45a.5.5,0,0,1,.5.5v51.76A.5.5,0,0,1,386,180Zm-44.47-1h44V128.21h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.14,
    y: 131.35,
    width: 38.65,
    height: 44.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,176.33H344.14a.5.5,0,0,1-.5-.5V131.35a.5.5,0,0,1,.5-.5h38.65a.5.5,0,0,1,.5.5v44.48A.5.5,0,0,1,382.79,176.33Zm-38.15-1h37.65V131.85H344.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.13,
    y: 140.54,
    width: 22.67,
    height: 26.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,167.14H352.13a.5.5,0,0,1-.5-.5v-26.1a.5.5,0,0,1,.5-.5H374.8a.5.5,0,0,1,.5.5v26.1A.5.5,0,0,1,374.8,167.14Zm-22.17-1H374.3V141H352.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.98,
    y: 201.54,
    width: 44.98,
    height: 51.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,253.8H341a.5.5,0,0,1-.5-.5V201.54a.5.5,0,0,1,.5-.5h45a.5.5,0,0,1,.5.5V253.3A.5.5,0,0,1,386,253.8Zm-44.47-1h44V202h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.14,
    y: 205.18,
    width: 38.65,
    height: 44.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,250.16H344.14a.5.5,0,0,1-.5-.5V205.18a.5.5,0,0,1,.5-.5h38.65a.5.5,0,0,1,.5.5v44.48A.5.5,0,0,1,382.79,250.16Zm-38.15-1h37.65V205.68H344.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.13,
    y: 214.37,
    width: 22.67,
    height: 26.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.8,241H352.13a.5.5,0,0,1-.5-.5v-26.1a.5.5,0,0,1,.5-.5H374.8a.5.5,0,0,1,.5.5v26.1A.5.5,0,0,1,374.8,241Zm-22.17-1H374.3v-25.1H352.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pictures-1--inject-403"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.34,
    y: 159.11,
    width: 44.98,
    height: 51.77,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.31,211.37h-45a.5.5,0,0,1-.5-.5V159.11a.5.5,0,0,1,.5-.5h45a.5.5,0,0,1,.5.5v51.76A.5.5,0,0,1,165.31,211.37Zm-44.47-1h44V159.61h-44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 162.75,
    width: 38.65,
    height: 44.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,207.73H123.5a.5.5,0,0,1-.5-.5V162.75a.5.5,0,0,1,.5-.5h38.65a.5.5,0,0,1,.5.5v44.48A.51.51,0,0,1,162.15,207.73Zm-38.15-1h37.65V163.25H124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.49,
    y: 171.94,
    width: 22.67,
    height: 26.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16,198.53H131.49a.5.5,0,0,1-.5-.5V171.94a.5.5,0,0,1,.5-.5h22.67a.51.51,0,0,1,.5.5V198A.5.5,0,0,1,154.16,198.53Zm-22.17-1h21.67V172.44H132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.71,
    y: 117.67,
    width: 30.23,
    height: 34.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,153H127.71a.5.5,0,0,1-.5-.5V117.67a.5.5,0,0,1,.5-.5h30.23a.5.5,0,0,1,.5.5v34.79A.51.51,0,0,1,157.94,153Zm-29.73-1h29.23V118.17H128.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.84,
    y: 120.11,
    width: 25.98,
    height: 29.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,150.51h-26a.5.5,0,0,1-.5-.5v-29.9a.5.5,0,0,1,.5-.5h26a.5.5,0,0,1,.5.5V150A.5.5,0,0,1,155.81,150.51Zm-25.47-1h25v-28.9h-25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2,
    y: 126.29,
    width: 15.24,
    height: 17.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,144.33H135.2a.5.5,0,0,1-.5-.5V126.29a.51.51,0,0,1,.5-.5h15.24a.5.5,0,0,1,.5.5v17.54A.5.5,0,0,1,150.44,144.33Zm-14.74-1h14.24V126.79H135.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.71,
    y: 221.54,
    width: 30.23,
    height: 34.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.94,256.83H127.71a.5.5,0,0,1-.5-.5V221.54a.5.5,0,0,1,.5-.5h30.23a.5.5,0,0,1,.5.5v34.79A.5.5,0,0,1,157.94,256.83Zm-29.73-1h29.23V222H128.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.84,
    y: 223.99,
    width: 25.98,
    height: 29.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,254.38h-26a.5.5,0,0,1-.5-.5V224a.5.5,0,0,1,.5-.5h26a.5.5,0,0,1,.5.5v29.89A.5.5,0,0,1,155.81,254.38Zm-25.47-1h25V224.49h-25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2,
    y: 230.17,
    width: 15.24,
    height: 17.54,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.44,248.2H135.2a.5.5,0,0,1-.5-.5V230.17a.5.5,0,0,1,.5-.5h15.24a.5.5,0,0,1,.5.5V247.7A.5.5,0,0,1,150.44,248.2Zm-14.74-1h14.24V230.67H135.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-403"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 174.15,
    y: 112.97,
    width: 157.74,
    height: 165.01,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,278.48H174.15a.5.5,0,0,1-.5-.5V113a.5.5,0,0,1,.5-.5H331.89a.51.51,0,0,1,.5.5V278A.5.5,0,0,1,331.89,278.48Zm-157.24-1H331.39v-164H174.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.42,
    y: 116.4,
    width: 151.19,
    height: 158.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.61,275.05H177.42a.5.5,0,0,1-.5-.5V116.4a.5.5,0,0,1,.5-.5H328.61a.5.5,0,0,1,.5.5V274.55A.5.5,0,0,1,328.61,275.05Zm-150.69-1H328.11V116.9H177.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.39,157.29a.5.5,0,0,1-.35-.15.51.51,0,0,1,0-.71L322.49,124a.5.5,0,1,1,.71.71l-32.45,32.45A.51.51,0,0,1,290.39,157.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.65,173.69a.47.47,0,0,1-.35-.15.5.5,0,0,1,0-.71L307.14,154a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71L289,173.54A.49.49,0,0,1,288.65,173.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92,252.9a.51.51,0,0,1-.36-.15.51.51,0,0,1,0-.71L219.2,215.4a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-36.64,36.64A.49.49,0,0,1,182.92,252.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.14,215.91a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l8.73-8.73a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71l-8.72,8.72A.5.5,0,0,1,210.14,215.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.86,255a.5.5,0,0,1-.35-.85l8.72-8.73a.5.5,0,1,1,.71.71l-8.72,8.72A.51.51,0,0,1,300.86,255Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.47,
    y: 116.4,
    width: 7.09,
    height: 158.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.56,275.05h-7.09a.5.5,0,0,1-.5-.5V116.4a.5.5,0,0,1,.5-.5h7.09a.5.5,0,0,1,.5.5V274.55A.5.5,0,0,1,256.56,275.05Zm-6.59-1h6.09V116.9H250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.89,
    y: 105.99,
    width: 180.25,
    height: 6.73,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.14,113.21H162.89a.5.5,0,0,1-.5-.5V106a.5.5,0,0,1,.5-.5H343.14a.5.5,0,0,1,.5.5v6.72A.5.5,0,0,1,343.14,113.21Zm-179.75-1H342.64v-5.72H163.39Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.48,320.21H349.9V317.4h2.58a1.81,1.81,0,0,0,1.8-1.81v-4a1.81,1.81,0,0,0-1.8-1.81h-2.8v-2.81h2.8a4.63,4.63,0,0,1,4.62,4.62v4A4.63,4.63,0,0,1,352.48,320.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.48,320.71H349.9a.5.5,0,0,1-.5-.5V317.4a.5.5,0,0,1,.5-.5h2.58a1.31,1.31,0,0,0,1.3-1.31v-4a1.31,1.31,0,0,0-1.3-1.31h-2.81a.5.5,0,0,1-.5-.5v-2.81a.5.5,0,0,1,.5-.5h2.81a5.13,5.13,0,0,1,5.12,5.12v4A5.12,5.12,0,0,1,352.48,320.71Zm-2.08-1h2.08a4.12,4.12,0,0,0,4.12-4.12v-4a4.13,4.13,0,0,0-4.12-4.12h-2.31v1.81h2.31a2.31,2.31,0,0,1,2.3,2.31v4a2.3,2.3,0,0,1-2.3,2.31H350.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.86,
    y: 305.66,
    width: 14.71,
    height: 17.16,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57,323.32H335.86a.5.5,0,0,1-.5-.5V305.66a.5.5,0,0,1,.5-.5h14.71a.51.51,0,0,1,.5.5v17.16A.51.51,0,0,1,350.57,323.32Zm-14.21-1h13.71V306.16H336.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.28,
    y: 319.88,
    width: 18,
    height: 2.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,323.29h-18a.5.5,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h18a.5.5,0,0,1,.5.5v2.91A.51.51,0,0,1,331.28,323.29Zm-17.5-1h17v-1.91h-17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.94 319.46 325.88 318.49 328.51 318.49 330.86 318.21 331.28 319.88 323.94 319.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,320.38h0l-7.34-.42a.49.49,0,0,1-.46-.4.5.5,0,0,1,.26-.55l1.94-1a.59.59,0,0,1,.23-.05h2.63l2.29-.27a.5.5,0,0,1,.55.37l.41,1.67a.51.51,0,0,1-.1.44A.49.49,0,0,1,331.28,320.38Zm-5.44-1.31,4.79.27-.15-.58-1.91.23H326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.48 319.46 322.28 317.38 323.94 317.25 325.05 317.38 325.88 318.49 323.94 319.46 320.48 319.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.94,320h-3.46a.5.5,0,0,1-.46-.29.51.51,0,0,1,.08-.54l1.8-2.07a.47.47,0,0,1,.33-.17l1.67-.14h.1l1.11.14a.58.58,0,0,1,.34.19l.83,1.11a.48.48,0,0,1,.08.42.51.51,0,0,1-.26.33l-1.94,1A.59.59,0,0,1,323.94,320Zm-2.37-1h2.25l1.3-.65-.35-.46-.84-.1-1.41.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.8,319.46l-1.52-1.11h-1.94a2,2,0,0,1,0-1.38,1.12,1.12,0,0,1,1.24-.69,16.86,16.86,0,0,1,2.36.69l2.77,2.21,1.1.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,320.38h-.05l-4-.41a.5.5,0,0,1-.24-.09l-1.4-1h-1.77a.5.5,0,0,1-.47-.31,2.58,2.58,0,0,1,0-1.76,1.62,1.62,0,0,1,1.71-1,13.51,13.51,0,0,1,2.53.72.39.39,0,0,1,.14.08l2.77,2.21,1.06.66a.5.5,0,0,1-.27.93ZM315,319l1.92.2-2.21-1.77a16.12,16.12,0,0,0-2.11-.63c-.45,0-.64,0-.78.37a1.35,1.35,0,0,0-.07.7h1.55a.53.53,0,0,1,.29.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.94,317a16.86,16.86,0,0,0-2.36-.69,1.12,1.12,0,0,0-1.24.69,2,2,0,0,0,0,1.38h1.94l.93.68a.62.62,0,0,0,0-.3C313.77,317.14,314.94,317,314.94,317Z",
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.21,319.53a.47.47,0,0,1-.3-.1l-.8-.58h-1.77a.5.5,0,0,1-.47-.31,2.58,2.58,0,0,1,0-1.76,1.62,1.62,0,0,1,1.71-1,13.51,13.51,0,0,1,2.53.72.49.49,0,0,1,.32.52.48.48,0,0,1-.41.44.58.58,0,0,0-.32.22,1.19,1.19,0,0,0,0,.91,1.06,1.06,0,0,1,0,.56.5.5,0,0,1-.31.35Zm-2.48-1.68h1.55a.53.53,0,0,1,.29.1l0,0a1.58,1.58,0,0,1,.26-.85,8.43,8.43,0,0,0-1.29-.35c-.45,0-.64,0-.78.37A1.35,1.35,0,0,0,311.73,317.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.64,305.1a.43.43,0,0,1-.19,0,.51.51,0,0,1-.28-.65,9.66,9.66,0,0,1,1-1.92.5.5,0,0,1,.7-.11.51.51,0,0,1,.11.7,8.27,8.27,0,0,0-.91,1.7A.49.49,0,0,1,316.64,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,319.08a.51.51,0,0,1-.32-.12.49.49,0,0,1-.06-.7,3.57,3.57,0,0,0,.43-4.57,14.67,14.67,0,0,0-1.14-1.31,10.14,10.14,0,0,1-1.71-2.18,5.86,5.86,0,0,1-.65-3.55.5.5,0,0,1,1,.11,4.85,4.85,0,0,0,.53,3,9.54,9.54,0,0,0,1.56,2,14.19,14.19,0,0,1,1.21,1.39c1.27,1.71,1.09,3.93-.46,5.81A.51.51,0,0,1,319,319.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.71,313.23a.49.49,0,0,1-.49-.41,3.82,3.82,0,0,0-1.07-1.5A13.4,13.4,0,0,1,318.3,309a3.77,3.77,0,0,1-.07-4.15.51.51,0,0,1,.7-.1.5.5,0,0,1,.11.69,2.8,2.8,0,0,0,.12,3,12.63,12.63,0,0,0,1.72,2.17,4.24,4.24,0,0,1,1.32,2,.5.5,0,0,1-.4.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.21,320.74v-4.33a2.54,2.54,0,0,0-2.54-2.54H305.6a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.54H281.67A2.54,2.54,0,0,0,284.21,320.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.6,323.78H281.67a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5,2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2,.5.5,0,1,1,0-1H305.6a3,3,0,0,1,3,3v4.33A3.05,3.05,0,0,1,305.6,323.78Zm-21.68-1H305.6a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H283.92a3,3,0,0,1,.79,2v4.33A3,3,0,0,1,283.92,322.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.37,314.21l-.29-.18a.09.09,0,0,1,.05-.16h21.54a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.54H260.13a.09.09,0,0,1-.05-.16l.29-.19Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.67,323.78H260.13a.59.59,0,0,1-.32-1.08l.06,0v-8.18l-.06,0a.59.59,0,0,1,.32-1.08h21.54a3,3,0,0,1,3,3v4.33A3,3,0,0,1,281.67,323.78Zm-20.8-1h20.8a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2h-20.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,314.21h21.76a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H262a1.61,1.61,0,0,1-1.61-1.61v-5.49A1.61,1.61,0,0,1,262,314.21Z",
    transform: "translate(544.11 637.15) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,323.43H260.37a.5.5,0,0,1-.5-.5v-8.72a.5.5,0,0,1,.5-.5h21.76a2.12,2.12,0,0,1,2.11,2.12v5.49A2.11,2.11,0,0,1,282.13,323.43Zm-21.26-1h21.26a1.11,1.11,0,0,0,1.11-1.11v-5.49a1.12,1.12,0,0,0-1.11-1.12H260.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,302v-4.33a2.54,2.54,0,0,0-2.54-2.54h23.93a2.54,2.54,0,0,1,2.54,2.54V302a2.54,2.54,0,0,1-2.54,2.54H278.41A2.54,2.54,0,0,0,281,302Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,305H278.41a.5.5,0,0,1,0-1,2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2,.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h23.93a3,3,0,0,1,3,3V302A3,3,0,0,1,302.34,305Zm-21.67-1h21.67a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2H280.67a3.08,3.08,0,0,1,.78,2V302A3.08,3.08,0,0,1,280.67,304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11,295.43l-.29-.19a.09.09,0,0,1,.05-.16h21.54a2.54,2.54,0,0,1,2.54,2.54V302a2.54,2.54,0,0,1-2.54,2.54H256.87a.09.09,0,0,1-.05-.16l.29-.18Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,305H256.87a.58.58,0,0,1-.56-.42.59.59,0,0,1,.24-.66l.06,0V295.7l-.06,0a.59.59,0,0,1-.24-.66.58.58,0,0,1,.56-.42h21.54a3,3,0,0,1,3,3V302A3,3,0,0,1,278.41,305Zm-21.31-.24Zm.51-.76h20.8a2,2,0,0,0,2-2v-4.33a2,2,0,0,0-2-2h-20.8Zm-.51-9.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72,295.43h21.76a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H258.72a1.61,1.61,0,0,1-1.61-1.61V297A1.61,1.61,0,0,1,258.72,295.43Z",
    transform: "translate(537.59 599.57) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.87,304.65H257.11a.5.5,0,0,1-.5-.5v-8.72a.5.5,0,0,1,.5-.5h21.76A2.11,2.11,0,0,1,281,297v5.49A2.12,2.12,0,0,1,278.87,304.65Zm-21.26-1h21.26a1.12,1.12,0,0,0,1.11-1.12V297a1.11,1.11,0,0,0-1.11-1.11H257.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.34,311.29V307a2.54,2.54,0,0,0-2.54-2.54h23.93a2.54,2.54,0,0,1,2.53,2.54v4.33a2.54,2.54,0,0,1-2.53,2.54H282.8A2.54,2.54,0,0,0,285.34,311.29Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.73,314.33H282.8a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5,2,2,0,0,0,2-2V307a2,2,0,0,0-2-2,.5.5,0,0,1,0-1h23.93a3,3,0,0,1,3,3v4.33A3,3,0,0,1,306.73,314.33Zm-21.68-1h21.68a2,2,0,0,0,2-2V307a2,2,0,0,0-2-2H285.05a3,3,0,0,1,.79,2v4.33A3,3,0,0,1,285.05,313.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.5,304.76l-.29-.18a.09.09,0,0,1,.05-.16H282.8a2.54,2.54,0,0,1,2.54,2.54v4.33a2.54,2.54,0,0,1-2.54,2.54H261.26a.09.09,0,0,1-.05-.16l.29-.19Z",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8,314.33H261.26a.59.59,0,0,1-.32-1.08l.06,0V305l-.06,0a.56.56,0,0,1-.24-.65.58.58,0,0,1,.56-.42H282.8a3,3,0,0,1,3,3v4.33A3,3,0,0,1,282.8,314.33Zm-21.31-.25h0Zm.51-.75h20.8a2,2,0,0,0,2-2V307a2,2,0,0,0-2-2H262Zm-.52-9.17h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.11,304.76h21.76a0,0,0,0,1,0,0v8.72a0,0,0,0,1,0,0H263.11a1.61,1.61,0,0,1-1.61-1.61v-5.49A1.61,1.61,0,0,1,263.11,304.76Z",
    transform: "translate(546.36 618.25) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.26,314H261.5a.5.5,0,0,1-.5-.5v-8.72a.5.5,0,0,1,.5-.5h21.76a2.12,2.12,0,0,1,2.11,2.12v5.49A2.12,2.12,0,0,1,283.26,314ZM262,313h21.26a1.11,1.11,0,0,0,1.11-1.11v-5.49a1.12,1.12,0,0,0-1.11-1.12H262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.5 318.84 267.43 316.9 269.36 318.84 269.36 307.82 265.5 307.82 265.5 318.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,319.34a.71.71,0,0,1-.2,0,.51.51,0,0,1-.3-.46v-11a.5.5,0,0,1,.5-.5h3.86a.5.5,0,0,1,.5.5v11a.51.51,0,0,1-.31.46.53.53,0,0,1-.55-.11l-1.57-1.58-1.58,1.58A.49.49,0,0,1,265.5,319.34Zm.5-11v9.31l1.07-1.08a.53.53,0,0,1,.36-.15h0a.51.51,0,0,1,.35.15l1.08,1.08v-9.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.31,
    y: 277.3,
    width: 4.76,
    height: 17.2,
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,295h-4.76a.5.5,0,0,1-.5-.5V277.3a.5.5,0,0,1,.5-.5h4.76a.5.5,0,0,1,.5.5v17.2A.5.5,0,0,1,174.07,295Zm-4.26-1h3.76V277.8h-3.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.54 311.23 168.83 311.23 169.31 294.03 174.07 294.03 174.54 311.23",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,311.73h-5.72a.48.48,0,0,1-.36-.15.54.54,0,0,1-.14-.36l.48-17.2a.49.49,0,0,1,.5-.49h4.76a.51.51,0,0,1,.5.49l.48,17.2a.51.51,0,0,1-.15.36A.47.47,0,0,1,174.55,311.73Zm-5.21-1H174l-.45-16.2h-3.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.54 311.23 168.83 311.23 156.8 322.71 186.57 322.71 174.54 311.23",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.57,323.21H156.8a.5.5,0,0,1-.34-.86l12-11.48a.52.52,0,0,1,.35-.14h5.72a.49.49,0,0,1,.34.14l12,11.48a.51.51,0,0,1,.12.55A.5.5,0,0,1,186.57,323.21Zm-28.52-1h27.28l-11-10.48H169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.93,280c-1.11-13.91-11.81-24.82-24.84-24.82S148.37,266.12,147.25,280Z",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.94,280.53H147.25a.48.48,0,0,1-.36-.16.45.45,0,0,1-.13-.38c1.16-14.41,12.05-25.28,25.33-25.28s24.18,10.87,25.34,25.28a.48.48,0,0,1-.13.38A.5.5,0,0,1,196.94,280.53Zm-49.14-1h48.59c-1.34-13.62-11.7-23.82-24.3-23.82S149.14,265.91,147.8,279.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 277.83,
    width: 51.39,
    height: 2.2,
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.79,280.53H146.4a.5.5,0,0,1-.5-.5v-2.2a.5.5,0,0,1,.5-.5h51.39a.5.5,0,0,1,.5.5V280A.5.5,0,0,1,197.79,280.53Zm-50.89-1h50.39v-1.2H146.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.99 286.27 177.21 286.27 183.84 322.82 229.62 322.82 222.99 286.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.62,323.32H183.84a.49.49,0,0,1-.49-.41l-6.64-36.55a.54.54,0,0,1,.11-.41.5.5,0,0,1,.39-.18H223a.49.49,0,0,1,.49.41l6.64,36.55a.5.5,0,0,1-.5.59Zm-45.36-1H229l-6.46-35.55H177.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.41 288.68 180.66 288.68 186.42 320.41 226.17 320.41 220.41 288.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.17,320.91H186.42a.49.49,0,0,1-.49-.41l-5.76-31.73a.5.5,0,0,1,.49-.59h39.75a.49.49,0,0,1,.49.41l5.76,31.73a.47.47,0,0,1-.11.41A.49.49,0,0,1,226.17,320.91Zm-39.33-1h38.73L220,289.18H181.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.97,
    y: 320.55,
    width: 45.78,
    height: 2.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.75,323.32H221a.5.5,0,0,1-.5-.5v-2.27a.5.5,0,0,1,.5-.5h45.78a.5.5,0,0,1,.5.5v2.27A.5.5,0,0,1,266.75,323.32Zm-45.28-1h44.78v-1.27H221.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.73,
    y: 320.55,
    width: 45.78,
    height: 2.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51,323.32H183.73a.51.51,0,0,1-.5-.5v-2.27a.5.5,0,0,1,.5-.5h45.78a.5.5,0,0,1,.5.5v2.27A.5.5,0,0,1,229.51,323.32Zm-45.28-1H229v-1.27H184.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.77,
    y: 325.44,
    width: 61.08,
    height: 121.91,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.85,447.85H156.77a.5.5,0,0,1-.5-.5V325.44a.5.5,0,0,1,.5-.5h61.08a.5.5,0,0,1,.5.5V447.35A.5.5,0,0,1,217.85,447.85Zm-60.58-1h60.08V325.94H157.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.77,
    y: 325.44,
    width: 61.08,
    height: 5.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.85,331.31H156.77a.5.5,0,0,1-.5-.5v-5.37a.5.5,0,0,1,.5-.5h61.08a.5.5,0,0,1,.5.5v5.37A.51.51,0,0,1,217.85,331.31Zm-60.58-1h60.08v-4.37H157.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 333.75,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,357.1H161.75a.5.5,0,0,1-.5-.5V333.75a.5.5,0,0,1,.5-.5h51.11a.5.5,0,0,1,.5.5V356.6A.5.5,0,0,1,212.86,357.1Zm-50.61-1h50.11V334.25H162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.24,
    y: 343.72,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,347.13H180.24a.51.51,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5v2.91A.5.5,0,0,1,194.37,347.13Zm-13.63-1h13.13v-1.91H180.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 362.42,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,385.77H161.75a.5.5,0,0,1-.5-.5V362.42a.5.5,0,0,1,.5-.5h51.11a.5.5,0,0,1,.5.5v22.85A.5.5,0,0,1,212.86,385.77Zm-50.61-1h50.11V362.92H162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.24,
    y: 372.39,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,375.8H180.24a.51.51,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5v2.91A.5.5,0,0,1,194.37,375.8Zm-13.63-1h13.13v-1.91H180.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 391.09,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,414.44H161.75a.51.51,0,0,1-.5-.5V391.09a.5.5,0,0,1,.5-.5h51.11a.5.5,0,0,1,.5.5v22.85A.5.5,0,0,1,212.86,414.44Zm-50.61-1h50.11V391.59H162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.24,
    y: 401.06,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,404.47H180.24a.51.51,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5V404A.5.5,0,0,1,194.37,404.47Zm-13.63-1h13.13v-1.91H180.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.75,
    y: 419.76,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,443.11H161.75a.51.51,0,0,1-.5-.5V419.76a.5.5,0,0,1,.5-.5h51.11a.5.5,0,0,1,.5.5v22.85A.5.5,0,0,1,212.86,443.11Zm-50.61-1h50.11V420.26H162.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.24,
    y: 429.73,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,433.14H180.24a.51.51,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5v2.91A.5.5,0,0,1,194.37,433.14Zm-13.63-1h13.13v-1.91H180.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 325.44,
    width: 61.08,
    height: 121.91,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.18,447.85H309.1a.5.5,0,0,1-.5-.5V325.44a.5.5,0,0,1,.5-.5h61.08a.5.5,0,0,1,.5.5V447.35A.5.5,0,0,1,370.18,447.85Zm-60.58-1h60.08V325.94H309.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 325.44,
    width: 61.08,
    height: 5.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.18,331.31H309.1a.51.51,0,0,1-.5-.5v-5.37a.5.5,0,0,1,.5-.5h61.08a.5.5,0,0,1,.5.5v5.37A.5.5,0,0,1,370.18,331.31Zm-60.58-1h60.08v-4.37H309.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.09,
    y: 333.75,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.2,357.1H314.09a.5.5,0,0,1-.5-.5V333.75a.5.5,0,0,1,.5-.5H365.2a.5.5,0,0,1,.5.5V356.6A.5.5,0,0,1,365.2,357.1Zm-50.61-1H364.7V334.25H314.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.58,
    y: 343.72,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,347.13H332.58a.5.5,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5v2.91A.51.51,0,0,1,346.71,347.13Zm-13.63-1h13.13v-1.91H333.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.09,
    y: 362.42,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.2,385.77H314.09a.5.5,0,0,1-.5-.5V362.42a.5.5,0,0,1,.5-.5H365.2a.5.5,0,0,1,.5.5v22.85A.5.5,0,0,1,365.2,385.77Zm-50.61-1H364.7V362.92H314.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.58,
    y: 372.39,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,375.8H332.58a.5.5,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5v2.91A.51.51,0,0,1,346.71,375.8Zm-13.63-1h13.13v-1.91H333.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.09,
    y: 391.09,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.2,414.44H314.09a.5.5,0,0,1-.5-.5V391.09a.5.5,0,0,1,.5-.5H365.2a.5.5,0,0,1,.5.5v22.85A.51.51,0,0,1,365.2,414.44Zm-50.61-1H364.7V391.59H314.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.58,
    y: 401.06,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,404.47H332.58a.5.5,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5V404A.51.51,0,0,1,346.71,404.47Zm-13.63-1h13.13v-1.91H333.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.09,
    y: 419.76,
    width: 51.11,
    height: 22.85,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.2,443.11H314.09a.5.5,0,0,1-.5-.5V419.76a.5.5,0,0,1,.5-.5H365.2a.5.5,0,0,1,.5.5v22.85A.51.51,0,0,1,365.2,443.11Zm-50.61-1H364.7V420.26H314.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.58,
    y: 429.73,
    width: 14.13,
    height: 2.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,433.14H332.58a.5.5,0,0,1-.5-.5v-2.91a.5.5,0,0,1,.5-.5h14.13a.5.5,0,0,1,.5.5v2.91A.51.51,0,0,1,346.71,433.14Zm-13.63-1h13.13v-1.91H333.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.85,
    y: 322.65,
    width: 220.1,
    height: 5.63,
    style: {
      fill: "#BD95CF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,328.78H152.85a.5.5,0,0,1-.5-.5v-5.63a.5.5,0,0,1,.5-.5H372.94a.5.5,0,0,1,.5.5v5.63A.5.5,0,0,1,372.94,328.78Zm-219.59-1H372.44v-4.63H153.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-403"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.29,377.66a2.28,2.28,0,0,1-.84-.16,2.2,2.2,0,0,1-1.18-2.86c3.52-8.49,7.57-23.63,3.42-28.15-1-.66-6.78-2.07-38.16.8l-2.28.21c-2.19.16-4.06,3-4.55,3.92a2.18,2.18,0,1,1-3.91-1.95c.31-.61,3.11-6,8.12-6.33l2.22-.2c33.43-3.07,39.84-1.53,41.79.6,7.36,8-1.57,30.27-2.61,32.78A2.18,2.18,0,0,1,184.29,377.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,378.16a2.78,2.78,0,0,1-1-.2,2.66,2.66,0,0,1-1.45-1.46,2.61,2.61,0,0,1,0-2.05c3.72-9,7.26-23.4,3.56-27.57-.72-.43-5.66-2-37.79.91l-2.29.21c-1.82.13-3.57,2.51-4.14,3.65a2.69,2.69,0,0,1-4.81-2.41c.32-.63,3.26-6.2,8.54-6.6l2-.18.26,0c35.32-3.24,40.3-1.31,42.2.76,7.57,8.26-1.46,30.77-2.52,33.31A2.68,2.68,0,0,1,184.29,378.16Zm-7.78-33.1c6.85,0,8.88.61,9.47,1l.08.08c4.33,4.72.38,19.73-3.33,28.67a1.7,1.7,0,0,0,0,1.29,1.66,1.66,0,0,0,.91.91,1.71,1.71,0,0,0,2.21-.91c1-2.48,9.85-24.44,2.7-32.24-1.77-1.94-8.07-3.5-41.37-.44l-.26,0c-.91.08-1.59.15-2,.17-4.73.37-7.42,5.48-7.71,6.06a1.69,1.69,0,0,0,3,1.51c.55-1.11,2.51-4,5-4.2l2.28-.2C161.79,345.49,170.81,345.06,176.51,345.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.34,280.68s-1.73,6.75-.85,11,8.76,22.66,14.61,39.59,4.67,35.36,4.67,40.8-.29,9.36,3.8,11.48,10.51.91,12.27-3,2.92-29-.29-44.13-13.07-38.17-16-44.21S120.15,272.52,109.34,280.68Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,385.07a10.36,10.36,0,0,1-4.76-1.1c-4.1-2.12-4.09-6-4.07-10.9v-1c0-.64,0-1.45,0-2.41.14-7,.46-23.35-4.68-38.23-2.87-8.33-6.29-17.13-9-24.21-2.87-7.4-5.14-13.25-5.59-15.44-.89-4.3.79-10.93.86-11.21a.5.5,0,0,1,.18-.27c3-2.25,5.78-3.06,8.3-2.42,4.84,1.23,7.66,7.47,9.72,12,.33.74.65,1.44.95,2.06,3,6.24,12.82,29.28,16,44.33,3.17,14.86,2.17,40.16.26,44.43a7.26,7.26,0,0,1-4.42,3.72A11.27,11.27,0,0,1,136.1,385.07ZM109.79,281c-.26,1.06-1.58,6.88-.81,10.58.43,2.11,2.69,7.93,5.54,15.29,2.75,7.09,6.17,15.9,9,24.24,5.19,15.05,4.87,31.54,4.73,38.58,0,1,0,1.76,0,2.39v1c0,4.92,0,8.18,3.53,10a10.26,10.26,0,0,0,7.74.41,6.32,6.32,0,0,0,3.84-3.19c1.61-3.61,2.9-28.65-.32-43.81-3.18-15-12.95-37.89-16-44.11-.31-.62-.62-1.33-1-2.08-2-4.37-4.68-10.36-9.06-11.47C114.91,278.27,112.46,279,109.79,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,282.29s-3.21,5.14-2.33,9.37,8.76,22.66,14.6,39.59,4.68,35.36,4.68,40.8-.29,9.36,3.8,11.48,10.51.91,12.27-3,2.92-29-.3-44.13-14.6-41.7-17.52-47.75S117.35,274.13,106.54,282.29Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.42,279.43a11.34,11.34,0,0,0-7,7.84,9.87,9.87,0,0,0-.23,4.39c.87,4.23,8.76,22.66,14.6,39.59s4.68,35.36,4.68,40.8-.29,9.36,3.8,11.48,10.51.91,12.27-3,2.92-29-.3-44.13-14.6-41.7-17.52-47.75C119.33,283.65,117.91,277,111.42,279.43Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82,385.07a10.36,10.36,0,0,1-4.76-1.1c-4.1-2.12-4.09-6-4.07-10.91v-1c0-.64,0-1.45,0-2.41.14-7,.46-23.35-4.68-38.23-2.87-8.32-6.29-17.13-9-24.2-2.87-7.41-5.14-13.26-5.59-15.45a10.29,10.29,0,0,1,.24-4.62,11.84,11.84,0,0,1,7.28-8.18h0c5.9-2.19,8,2.7,9.85,7,.36.83.71,1.66,1.1,2.45,2.79,5.78,14.28,32.44,17.56,47.86,3.16,14.86,2.17,40.16.26,44.43a7.26,7.26,0,0,1-4.42,3.72A11.27,11.27,0,0,1,131.82,385.07ZM111.59,279.9a10.78,10.78,0,0,0-6.66,7.49,9.28,9.28,0,0,0-.23,4.16c.43,2.11,2.69,7.93,5.54,15.3,2.75,7.08,6.17,15.89,9.05,24.23,5.19,15.05,4.87,31.54,4.73,38.58,0,1,0,1.76,0,2.39v1c0,4.92,0,8.18,3.53,10a10.26,10.26,0,0,0,7.74.41,6.32,6.32,0,0,0,3.84-3.19c1.61-3.61,2.9-28.65-.32-43.81-3.26-15.33-14.71-41.88-17.49-47.64-.39-.8-.75-1.64-1.12-2.49-1.91-4.47-3.57-8.32-8.58-6.46Zm-.17-.47h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.53,
    y: 380,
    width: 3.92,
    height: 37.78,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,418.28h-3.92a.51.51,0,0,1-.5-.5V380a.5.5,0,0,1,.5-.5h3.92a.5.5,0,0,1,.5.5v37.78A.5.5,0,0,1,168.45,418.28Zm-3.42-1H168V380.5H165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.47 419.32 171.47 412.95 161.52 412.95 161.52 419.38 121.71 434.67 121.71 442.21 124.42 442.21 124.42 436.48 166.64 427.56 207.74 436.48 207.74 442.21 210.38 442.21 210.38 434.67 171.47 419.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.38,442.71h-2.64a.5.5,0,0,1-.5-.5v-5.33l-40.6-8.81-41.72,8.81v5.33a.5.5,0,0,1-.5.5h-2.71a.5.5,0,0,1-.5-.5v-7.54a.49.49,0,0,1,.32-.47L161,419V413a.5.5,0,0,1,.5-.5h9.95a.5.5,0,0,1,.5.5v6l38.59,15.22a.51.51,0,0,1,.32.47v7.54A.51.51,0,0,1,210.38,442.71Zm-2.14-1h1.64V435l-38.59-15.23a.5.5,0,0,1-.32-.46v-5.87H162v5.93a.5.5,0,0,1-.32.46L122.21,435v6.7h1.71v-5.23a.5.5,0,0,1,.4-.49l42.21-8.92a.38.38,0,0,1,.21,0l41.1,8.92a.5.5,0,0,1,.4.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.69,
    y: 380,
    width: 19.6,
    height: 12.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.3,392.56H156.69a.5.5,0,0,1-.5-.5V380a.5.5,0,0,1,.5-.5H176.3a.5.5,0,0,1,.5.5v12.06A.5.5,0,0,1,176.3,392.56Zm-19.11-1H175.8V380.5H157.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.48,
    cy: 442.51,
    r: 4.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.48,447.23a4.72,4.72,0,1,1,4.73-4.72A4.73,4.73,0,0,1,117.48,447.23Zm0-8.44a3.72,3.72,0,1,0,3.73,3.72A3.73,3.73,0,0,0,117.48,438.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29,442.51a1.81,1.81,0,1,0-1.81,1.81A1.81,1.81,0,0,0,119.29,442.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.48,444.82a2.31,2.31,0,1,1,2.31-2.31A2.32,2.32,0,0,1,117.48,444.82Zm0-3.62a1.31,1.31,0,1,0,1.31,1.31A1.31,1.31,0,0,0,117.48,441.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.9,
    cy: 442.51,
    r: 4.22,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9,447.23a4.72,4.72,0,1,1,4.72-4.72A4.73,4.73,0,0,1,214.9,447.23Zm0-8.44a3.72,3.72,0,1,0,3.72,3.72A3.73,3.73,0,0,0,214.9,438.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.9,
    cy: 442.51,
    r: 1.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9,444.82a2.31,2.31,0,1,1,2.31-2.31A2.32,2.32,0,0,1,214.9,444.82Zm0-3.62a1.31,1.31,0,1,0,1.31,1.31A1.31,1.31,0,0,0,214.9,441.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.3 443.11 164.99 443.11 163.33 420.49 169.96 420.49 168.3 443.11",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,443.61H165a.49.49,0,0,1-.5-.46l-1.66-22.62a.5.5,0,0,1,.5-.54H170a.5.5,0,0,1,.5.54l-1.66,22.62A.49.49,0,0,1,168.3,443.61Zm-2.85-1h2.39L169.42,421h-5.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 438.29,
    width: 3.32,
    height: 9.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.15,448.14h-3.31a.5.5,0,0,1-.5-.5v-9.35a.5.5,0,0,1,.5-.5h3.31a.5.5,0,0,1,.5.5v9.35A.5.5,0,0,1,168.15,448.14Zm-2.81-1h2.31v-8.35h-2.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.05,
    y: 367.8,
    width: 63.34,
    height: 16.89,
    rx: 4.24,
    transform: "translate(-11.79 5.48) rotate(-1.81)",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.89,
    y: 367.8,
    width: 63.34,
    height: 16.89,
    rx: 4.24,
    transform: "translate(-11.79 5.7) rotate(-1.81)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.27,386.05a4.75,4.75,0,0,1-4.74-4.59l-.26-8.4a4.73,4.73,0,0,1,4.59-4.89l54.83-1.73a4.73,4.73,0,0,1,4.88,4.59l.27,8.4a4.75,4.75,0,0,1-4.59,4.89h0l-54.83,1.73Zm54.57-18.61h-.12l-54.83,1.73a3.7,3.7,0,0,0-2.61,1.18,3.74,3.74,0,0,0-1,2.68l.26,8.4a3.74,3.74,0,0,0,3.86,3.62l54.83-1.73a3.74,3.74,0,0,0,3.62-3.86l-.26-8.4a3.74,3.74,0,0,0-3.74-3.62Zm.4,16.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.05,
    y: 367.8,
    width: 63.34,
    height: 16.89,
    rx: 4.24,
    transform: "translate(-11.79 5.48) rotate(-1.81)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.43,386.05a4.73,4.73,0,0,1-4.73-4.59l-.27-8.4a4.73,4.73,0,0,1,4.59-4.89l54.83-1.73a4.75,4.75,0,0,1,4.89,4.59l.26,8.4a4.73,4.73,0,0,1-4.59,4.89h0l-54.83,1.73ZM195,367.44h-.12l-54.83,1.73a3.74,3.74,0,0,0-3.62,3.86l.26,8.4a3.78,3.78,0,0,0,1.18,2.61,3.64,3.64,0,0,0,2.68,1l54.83-1.73a3.7,3.7,0,0,0,2.61-1.18,3.74,3.74,0,0,0,1-2.68l-.26-8.4a3.74,3.74,0,0,0-3.74-3.62Zm.4,16.38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,377.66a2.24,2.24,0,0,1-.84-.16,2.18,2.18,0,0,1-1.18-2.86c3.52-8.49,7.56-23.63,3.42-28.15-1-.66-6.79-2.07-38.16.8l-2.28.21c-2.2.16-4.07,3-4.55,3.92a2.18,2.18,0,1,1-3.91-1.95c.3-.61,3.11-6,8.12-6.33l2.22-.2c33.43-3.07,39.84-1.53,41.78.6,7.37,8-1.56,30.27-2.6,32.78A2.19,2.19,0,0,1,178.11,377.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,378.16a2.74,2.74,0,0,1-1-.2,2.69,2.69,0,0,1-1.46-3.51c3.72-9,7.27-23.4,3.56-27.57-.72-.43-5.65-2-37.78.91l-2.3.21c-1.82.13-3.57,2.51-4.13,3.65a2.69,2.69,0,1,1-4.81-2.41c.32-.63,3.26-6.2,8.53-6.6l2-.18.26,0c35.32-3.24,40.3-1.31,42.19.76,7.58,8.26-1.46,30.77-2.51,33.31A2.68,2.68,0,0,1,178.11,378.16Zm-7.79-33.1c6.85,0,8.88.61,9.47,1a.34.34,0,0,1,.09.08c4.33,4.72.38,19.73-3.33,28.67a1.7,1.7,0,0,0,0,1.29,1.63,1.63,0,0,0,.91.91,1.71,1.71,0,0,0,2.2-.91c1-2.47,9.86-24.44,2.71-32.24-1.77-1.93-8.07-3.5-41.37-.44l-.26,0c-.92.08-1.59.15-2,.17-4.73.37-7.42,5.48-7.72,6.06a1.69,1.69,0,0,0,3,1.51c.55-1.11,2.52-4,5-4.2l2.27-.2C155.6,345.49,164.63,345.06,170.32,345.06Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingRoomBro);
export default __webpack_public_path__ + "static/media/writing-room-bro.16b5b6afd04372b03242fd7835140a6f.svg";
export { ForwardRef as ReactComponent };